import {Permission} from "src/app/Login/_guards/Permission";
import {FormAziendaComponent} from "../../app/Admin/form-azienda/form-azienda.component"
import {addModule} from "../Utility/ModuleUtility";
import {Brandizzazioni} from "../Modules/Brandizzazioni";
import {Ritiri} from "../Modules/Ritiri";
import {Progetto} from "src/app/Progetti/Models/Progetto";
import {ToastrService} from "ngx-toastr";
import {CampoAggiuntivo} from "../../app/shared/models/campo-aggiuntivo";
import {Promozioni, CategorieTable, ProdottiTable, ListinoPromozione} from "../Modules/Promozioni";
import {VociDiCostoComponent} from "../../app/Progetti/voci-di-costo/voci-di-costo.component";
import {forkJoin} from "rxjs";
import {map} from "rxjs/operators";
import {CalcIva} from "../../app/Progetti/Helpers";
import {ListaAziendeComponent} from "../../app/Admin/lista-aziende/lista-aziende.component";
import {EnvironmentModel} from "./Model";
import {Azienda} from "../../app/Admin/models/Azienda";
import {dateTimeStringToFormattedDate} from "../Utility/DateUtility";
import {ProgettoComponent} from "../../app/Progetti/progetto/progetto.component";
import {SanPellegrinoEnv} from "../Modules/Sanpellegrino/SanPellegrino";
import {SezioniSanpellegrino} from "../Modules/Sanpellegrino/SezioniSanpellegrino";
import {VerticalSidebarComponent} from "../../app/layouts/vertical-sidebar/vertical-sidebar.component";
import {AggiornamentoMassivoEnv} from "../Modules/Klima/AggiornamentoMassivo";
import {DynamicCrudService} from "../../app/shared/_services/dynamic-crud.service";
import {ApiPathsService} from "../../app/api-paths.service";


var AnnoCorrente = () => {
  var data = new Date();
  return data.getFullYear();
}

export const intraUeCountries: string[] = [

  "AUT",
  "BEL",
  "BGR",
  "CYP",
  "CZE",
  "DEU",
  "DNK",
  "EST",
  "ESP",
  "FIN",
  "FRA",
  "GRC",
  "HRV",
  "HUN",
  "IRL",
  "LTU",
  "LUX",
  "LVA",
  "MLT",
  "NLD",
  "POL",
  "PRT",
  "ROU",
  "SWE",
  "SVN",
  "SVK"


  
];
export function sanitize(string:string){
  var prov = string;
  prov = string.replace(/-/g, '').replace(/ /g, '').replace(/\//g,'').replace(/\\/g,'');
  return prov;
}
export const Zone: {id:number, label:string, provincia?:string,provinciaObject?:{id:string, label: string, regione_id: any}}[] =
  [
    {
      "provinciaObject": {
        "id": "BO",
        "label": "Bologna",
        "regione_id": 11
      },
      "id": 1,
      "label": "EMILIA - BOLOGNA"
    },
    {
      "provinciaObject": {
        "id": "CE",
        "label": "Caserta",
        "regione_id": 7
      },
      "id": 2,
      "label": "CAMPANIA - CASERTA"
    },
    {
      "provinciaObject": {
        "id": "BZ",
        "label": "Bolzano",
        "regione_id": 12
      },
      "id": 3,
      "label": "TRENTINOALTOADIGE - BOLZANO"
    },
    {
      "provinciaObject": {
        "id": "IS",
        "label": "Isernia",
        "regione_id": 14
      },
      "id": 4,
      "label": "MOLISE - ISERNIA"
    },
    {
      "provinciaObject": {
        "id": "IM",
        "label": "Imperia",
        "regione_id": 21
      },
      "id": 79,
      "label": "IMPERIA"
    },
    {
      "provinciaObject": {
        "id": "AR",
        "label": "Arezzo",
        "regione_id": 6
      },
      "id": 5,
      "label": "TOSCANA - AREZZO"
    },
    {
      "provinciaObject": {
        "id": "RA",
        "label": "Ravenna",
        "regione_id": 11
      },
      "id": 7,
      "label": "EMILIA - RAVENNA",
      "provincia": "RA"
    },
    {
      "provinciaObject": {
        "id": "SV",
        "label": "Savona",
        "regione_id": 17
      },
      "id": 13,
      "label": "LIGURIA - SAVONA"
    },
    {
      "provinciaObject": {
        "id": "LC",
        "label": "Lecco",
        "regione_id": 10
      },
      "id": 14,
      "label": "LOMBARDIA - LECCO"
    },
    {
      "provinciaObject": {
        "id": "AL",
        "label": "Alessandria",
        "regione_id": 2
      },
      "id": 18,
      "label": "PIEMONTE - ALESSANDRIA"
    },
    {
      "provinciaObject": {
        "id": "CI",
        "label": "Carbonia Iglesias",
        "regione_id": 13
      },
      "id": 19,
      "label": "SARDEGNA - CARBONIA/IGLESIAS"
    },
    {
      "provinciaObject": {
        "id": "FM",
        "label": "Fermo",
        "regione_id": 3
      },
      "id": 21,
      "label": "MARCHE - FERMO"
    },
    {
      "provinciaObject": {
        "id": "RN",
        "label": "Rimini",
        "regione_id": 11
      },
      "id": 23,
      "label": "EMILIA - RIMINI"
    },
    {
      "provinciaObject": {
        "id": "BR",
        "label": "Brindisi",
        "regione_id": 8
      },
      "id": 24,
      "label": "PUGLIA - BRINDISI"
    },
    {
      "provinciaObject": {
        "id": "FC",
        "label": "Forli-Cesena",
        "regione_id": 11
      },
      "id": 26,
      "label": "EMILIA - FORLI - CESENA",
      "provincia": "FC"
    },
    {
      "provinciaObject": {
        "id": "GO",
        "label": "Gorizia",
        "regione_id": 18
      },
      "id": 27,
      "label": "FRIULI - GORIZIA"
    },
    {
      "provinciaObject": {
        "id": "PV",
        "label": "Pavia",
        "regione_id": 10
      },
      "id": 29,
      "label": "LOMBARDIA - PAVIA"
    },
    {
      "provinciaObject": {
        "id": "AO",
        "label": "Aosta",
        "regione_id": 4
      },
      "id": 31,
      "label": "VALLE D'AOSTA - AOSTA"
    },
    {
      "provinciaObject": {
        "id": "CH",
        "label": "Chieti",
        "regione_id": 5
      },
      "id": 35,
      "label": "ABRUZZO- CHIETI"
    },
    {
      "provinciaObject": {
        "id": "BI",
        "label": "Biella",
        "regione_id": 2
      },
      "id": 36,
      "label": "PIEMONTE - BIELLA"
    },
    {
      "id": 37,
      "label": "PIEMONTE - PINEROLO"
    },
    {
      "provinciaObject": {
        "id": "SP",
        "label": "La-Spezia",
        "regione_id": 17
      },
      "id": 40,
      "label": "LIGURIA - LA SPEZIA"
    },
    {
      "provinciaObject": {
        "id": "LE",
        "label": "Lecce",
        "regione_id": 8
      },
      "id": 46,
      "label": "PUGLIA - LECCE"
    },
    {
      "id": 47,
      "label": "BOSNIA - HERZEGOVINA"
    },
    {
      "provinciaObject": {
        "id": "FI",
        "label": "Firenze",
        "regione_id": 6
      },
      "id": 57,
      "label": "TOSCANA - FIRENZE"
    },
    {
      "provinciaObject": {
        "id": "PC",
        "label": "Piacenza",
        "regione_id": 11
      },
      "id": 58,
      "label": "EMILIA ROMAGNA -PIACENZA",
      "provincia": "PC"
    },
    {
      "provinciaObject": {
        "id": "CB",
        "label": "Campobasso",
        "regione_id": 14
      },
      "id": 61,
      "label": "MOLISE - CAMPOBASSO"
    },
    {
      "id": 62,
      "label": "LAZIO - FONDI"
    },
    {
      "provinciaObject": {
        "id": "GR",
        "label": "Grosseto",
        "regione_id": 6
      },
      "id": 63,
      "label": "TOSCANA - GROSSETO"
    },
    {
      "provinciaObject": {
        "id": "VB",
        "label": "Verbania",
        "regione_id": 2
      },
      "id": 64,
      "label": "PIEMONTE - VERBANIA"
    },
    {
      "provinciaObject": {
        "id": "CR",
        "label": "Cremona",
        "regione_id": 10
      },
      "id": 65,
      "label": "LOMBARDIA - CREMONA"
    },
    {
      "provinciaObject": {
        "id": "MI",
        "label": "Milano",
        "regione_id": 10
      },
      "id": 66,
      "label": "LOMBARDIA - MILANO"
    },
    {
      "provinciaObject": {
        "id": "KR",
        "label": "Crotone",
        "regione_id": 15
      },
      "id": 67,
      "label": "CALABRIA -CROTONE"
    },
    {
      "provinciaObject": {
        "id": "MS",
        "label": "Massa-Carrara",
        "regione_id": 6
      },
      "id": 68,
      "label": "MASSA CARRARA - TOSCANA"
    },
    {
      "provinciaObject": {
        "id": "SA",
        "label": "Salerno",
        "regione_id": 7
      },
      "id": 69,
      "label": "CAMPANIA - SALERNO"
    },
    {
      "provinciaObject": {
        "id": "LT",
        "label": "Latina",
        "regione_id": 16
      },
      "id": 70,
      "label": "LAZIO - LATINA"
    },
    {
      "provinciaObject": {
        "id": "VV",
        "label": "Vibo-Valentia",
        "regione_id": 15
      },
      "id": 72,
      "label": "CALABRIA - VIBO VALENTIA"
    },
    {
      "provinciaObject": {
        "id": "FE",
        "label": "Ferrara",
        "regione_id": 11
      },
      "id": 74,
      "label": "EMILIA - FERRARA"
    },
    {
      "provinciaObject": {
        "id": "PE",
        "label": "Pescara",
        "regione_id": 5
      },
      "id": 75,
      "label": "ABRUZZO - PESCARA"
    },
    {
      "provinciaObject": {
        "id": "OT",
        "label": "Olbia Tempio",
        "regione_id": 13
      },
      "id": 76,
      "label": "OLBIA-TEMPIO"
    },
    {
      "provinciaObject": {
        "id": "OR",
        "label": "Oristano",
        "regione_id": 13
      },
      "id": 77,
      "label": "SARDEGNA - ORISTANO"
    },
    {
      "id": 78,
      "label": "SARDEGNA-SUD SARDEGNA (SU)"
    },
    {
      "provinciaObject": {
        "id": "VC",
        "label": "Vercelli",
        "regione_id": 2
      },
      "id": 80,
      "label": "PIEMONTE-VERCELLI"
    },
    {
      "provinciaObject": {
        "id": "CT",
        "label": "Catania",
        "regione_id": 1
      },
      "id": 81,
      "label": "SICILIA - CATANIA"
    },
    {
      "provinciaObject": {
        "id": "VT",
        "label": "Viterbo",
        "regione_id": 16
      },
      "id": 82,
      "label": "LAZIO - VITERBO"
    },
    {
      "provinciaObject": {
        "id": "PG",
        "label": "Perugia",
        "regione_id": 20
      },
      "id": 83,
      "label": "UMBRIA - PERUGIA"
    },
    {
      "provinciaObject": {
        "id": "RC",
        "label": "Reggio-Calabria",
        "regione_id": 15
      },
      "id": 84,
      "label": "CALABRIA  - REGGIO CALABRIA"
    },
    {
      "provinciaObject": {
        "id": "BT",
        "label": "Barletta-Andria-Trani",
        "regione_id": 8
      },
      "id": 85,
      "label": "PUGLIA - BARLETTA Andria Trani"
    },
    {
      "provinciaObject": {
        "id": "BN",
        "label": "Benevento",
        "regione_id": 7
      },
      "id": 86,
      "label": "CAMPANIA - BENEVENTO"
    },
    {
      "provinciaObject": {
        "id": "RM",
        "label": "Roma",
        "regione_id": 16
      },
      "id": 87,
      "label": "LAZIO - ROMA"
    },
    {
      "provinciaObject": {
        "id": "MO",
        "label": "Modena",
        "regione_id": 11
      },
      "id": 88,
      "label": "EMILIA - MODENA"
    },
    {
      "provinciaObject": {
        "id": "PA",
        "label": "Palermo",
        "regione_id": 1
      },
      "id": 89,
      "label": "SICILIA - PALERMO"
    },
    {
      "provinciaObject": {
        "id": "RI",
        "label": "Rieti",
        "regione_id": 16
      },
      "id": 90,
      "label": "LAZIO - RIETI"
    },
    {
      "provinciaObject": {
        "id": "VA",
        "label": "Varese",
        "regione_id": 10
      },
      "id": 91,
      "label": "LOMBARDIA - VARESE"
    },
    {
      "provinciaObject": {
        "id": "SI",
        "label": "Siena",
        "regione_id": 6
      },
      "id": 93,
      "label": "TOSCANA - SIENA"
    },
    {
      "provinciaObject": {
        "id": "CS",
        "label": "Cosenza",
        "regione_id": 15
      },
      "id": 94,
      "label": "CALABRIA - COSENZA"
    },
    {
      "provinciaObject": {
        "id": "RG",
        "label": "Ragusa",
        "regione_id": 1
      },
      "id": 95,
      "label": "SICILIA - RAGUSA"
    },
    {
      "provinciaObject": {
        "id": "AV",
        "label": "Avellino",
        "regione_id": 7
      },
      "id": 96,
      "label": "CAMPANIA - AVELLINO"
    },
    {
      "provinciaObject": {
        "id": "RE",
        "label": "Reggio-Emilia",
        "regione_id": 11
      },
      "id": 97,
      "label": "EMILIA - REGGIO EMILIA"
    },
    {
      "provinciaObject": {
        "id": "NO",
        "label": "Novara",
        "regione_id": 2
      },
      "id": 98,
      "label": "PIEMONTE - NOVARA"
    },
    {
      "provinciaObject": {
        "id": "AG",
        "label": "Agrigento",
        "regione_id": 1
      },
      "id": 99,
      "label": "SICILIA - AGRIGENTO"
    },
    {
      "provinciaObject": {
        "id": "PU",
        "label": "Pesaro-Urbino",
        "regione_id": 3
      },
      "id": 100,
      "label": "MARCHE - PESARO/URBINO"
    },
    {
      "provinciaObject": {
        "id": "CN",
        "label": "Cuneo",
        "regione_id": 2
      },
      "id": 101,
      "label": "PIEMONTE - CUNEO"
    },
    {
      "provinciaObject": {
        "id": "NU",
        "label": "Nuoro",
        "regione_id": 13
      },
      "id": 102,
      "label": "SARDEGNA - NUORO"
    },
    {
      "provinciaObject": {
        "id": "TN",
        "label": "Trento",
        "regione_id": 12
      },
      "id": 103,
      "label": "TRENTINO ALTO ADIGE - TRENTO"
    },
    {
      "provinciaObject": {
        "id": "TS",
        "label": "Trieste",
        "regione_id": 18
      },
      "id": 104,
      "label": "FRIULI VENEZIA GIULIA - TRIESTE",
      "provincia": "TS"
    },
    {
      "provinciaObject": {
        "id": "PZ",
        "label": "Potenza",
        "regione_id": 19
      },
      "id": 105,
      "label": "BASILICATA - POTENZA"
    },
    {
      "provinciaObject": {
        "id": "PD",
        "label": "Padova",
        "regione_id": 9
      },
      "id": 106,
      "label": "VENETO - PADOVA"
    },
    {
      "provinciaObject": {
        "id": "CB",
        "label": "Campobasso",
        "regione_id": 14
      },
      "id": 107,
      "label": "MOLISE - CAMPOBASSO"
    },
    {
      "provinciaObject": {
        "id": "CO",
        "label": "Como",
        "regione_id": 10
      },
      "id": 108,
      "label": "LOMBARDIA - COMO"
    },
    {
      "provinciaObject": {
        "id": "BA",
        "label": "Bari",
        "regione_id": 8
      },
      "id": 109,
      "label": "PUGLIA - BARI"
    },
    {
      "provinciaObject": {
        "id": "AN",
        "label": "Ancona",
        "regione_id": 3
      },
      "id": 110,
      "label": "MARCHE - ANCONA"
    },
    {
      "provinciaObject": {
        "id": "MB",
        "label": "Monza-Brianza",
        "regione_id": 10
      },
      "id": 111,
      "label": "LOMBARDIA - Monza-Brianza"
    },
    {
      "provinciaObject": {
        "id": "CZ",
        "label": "Catanzaro",
        "regione_id": 15
      },
      "id": 112,
      "label": "CALABRIA - CATANZARO"
    },
    {
      "provinciaObject": {
        "id": "BG",
        "label": "Bergamo",
        "regione_id": 10
      },
      "id": 113,
      "label": "LOMBARDIA - BERGAMO"
    },
    {
      "provinciaObject": {
        "id": "PO",
        "label": "Prato",
        "regione_id": 6
      },
      "id": 114,
      "label": "TOSCANA - PRATO"
    },
    {
      "provinciaObject": {
        "id": "VR",
        "label": "Verona",
        "regione_id": 9
      },
      "id": 115,
      "label": "VENETO - VERONA"
    },
    {
      "provinciaObject": {
        "id": "PI",
        "label": "Pisa",
        "regione_id": 6
      },
      "id": 116,
      "label": "TOSCANA - PISA"
    },
    {
      "provinciaObject": {
        "id": "TE",
        "label": "Teramo",
        "regione_id": 5
      },
      "id": 118,
      "label": "ABRUZZO-TERAMO"
    },
    {
      "provinciaObject": {
        "id": "AP",
        "label": "Ascoli-Piceno",
        "regione_id": 3
      },
      "id": 119,
      "label": "MARCHE-ASCOLI PICENO"
    },
    {
      "provinciaObject": {
        "id": "TA",
        "label": "Taranto",
        "regione_id": 8
      },
      "id": 120,
      "label": "PUGLIA - TARANTO"
    },
    {
      "provinciaObject": {
        "id": "LI",
        "label": "Livorno",
        "regione_id": 6
      },
      "id": 121,
      "label": "TOSCANA-LIVORNO"
    },
    {
      "provinciaObject": {
        "id": "TV",
        "label": "Treviso",
        "regione_id": 9
      },
      "id": 122,
      "label": "VENETO - TREVISO"
    },
    {
      "provinciaObject": {
        "id": "GE",
        "label": "Genova",
        "regione_id": 17
      },
      "id": 124,
      "label": "LIGURIA-GENOVA"
    },
    {
      "provinciaObject": {
        "id": "BL",
        "label": "Belluno",
        "regione_id": 9
      },
      "id": 125,
      "label": "VENETO-BELLUNO"
    },
    {
      "provinciaObject": {
        "id": "LO",
        "label": "Lodi",
        "regione_id": 10
      },
      "id": 126,
      "label": "LOMBARDIA - LODI"
    },
    {
      "provinciaObject": {
        "id": "VI",
        "label": "Vicenza",
        "regione_id": 9
      },
      "id": 127,
      "label": "VENETO-VICENZA"
    },
    {
      "provinciaObject": {
        "id": "TP",
        "label": "Trapani",
        "regione_id": 1
      },
      "id": 128,
      "label": "SICILIA-TRAPANI"
    },
    {
      "provinciaObject": {
        "id": "CL",
        "label": "Caltanissetta",
        "regione_id": 1
      },
      "id": 129,
      "label": "SICILIA-CALTANISSETTA"
    },
    {
      "provinciaObject": {
        "id": "FR",
        "label": "Frosinone",
        "regione_id": 16
      },
      "id": 130,
      "label": "LAZIO - FROSINONE"
    },
    {
      "provinciaObject": {
        "id": "FG",
        "label": "Foggia",
        "regione_id": 8
      },
      "id": 131,
      "label": "PUGLIA - FOGGIA"
    },
    {
      "provinciaObject": {
        "id": "MT",
        "label": "Matera",
        "regione_id": 19
      },
      "id": 132,
      "label": "BASILICATA - MATERA"
    },
    {
      "provinciaObject": {
        "id": "LU",
        "label": "Lucca",
        "regione_id": 6
      },
      "id": 133,
      "label": "TOSCANA - LUCCA"
    },
    {
      "provinciaObject": {
        "id": "PT",
        "label": "Pistoia",
        "regione_id": 6
      },
      "id": 134,
      "label": "TOSCANA - PISTOIA"
    },
    {
      "provinciaObject": {
        "id": "MC",
        "label": "Macerata",
        "regione_id": 3
      },
      "id": 135,
      "label": "MARCHE - MACERATA"
    },
    {
      "provinciaObject": {
        "id": "MB",
        "label": "Monza-Brianza",
        "regione_id": 10
      },
      "id": 136,
      "label": "LOMBARDIA - MONZA BRIANZA"
    },
    {
      "provinciaObject": {
        "id": "BS",
        "label": "Brescia",
        "regione_id": 10
      },
      "id": 137,
      "label": "LOMBARDIA- BRESCIA"
    },
    {
      "provinciaObject": {
        "id": "AQ",
        "label": "L'Aquila",
        "regione_id": 5
      },
      "id": 138,
      "label": "ABRUZZO- L'AQUILA"
    },
    {
      "provinciaObject": {
        "id": "VE",
        "label": "Venezia",
        "regione_id": 9
      },
      "id": 139,
      "label": "VENETO-VENEZIA"
    },
    {
      "provinciaObject": {
        "id": "ME",
        "label": "Messina",
        "regione_id": 1
      },
      "id": 140,
      "label": "SICILIA-MESSINA"
    },
    {
      "provinciaObject": {
        "id": "TO",
        "label": "Torino",
        "regione_id": 2
      },
      "id": 141,
      "label": "PIEMONTE - TORINO"
    },
    {
      "provinciaObject": {
        "id": "NA",
        "label": "Napoli",
        "regione_id": 7
      },
      "id": 142,
      "label": "CAMPANIA - NAPOLI"
    },
    {
      "provinciaObject": {
        "id": "TR",
        "label": "Terni",
        "regione_id": 20
      },
      "id": 143,
      "label": "UMBRIA - TERNI"
    },
    {
      "provinciaObject": {
        "id": "PN",
        "label": "Pordenone",
        "regione_id": 18
      },
      "id": 144,
      "label": "FRIULI VENEZIA GIULIA- PORDENONE",
      "provincia": "PN"
    },
    {
      "provinciaObject": {
        "id": "VS",
        "label": "Medio Campidano",
        "regione_id": 13
      },
      "id": 145,
      "label": "SARDEGNA -Medio Campidano (VS)"
    },
    {
      "provinciaObject": {
        "id": "CA",
        "label": "Cagliari",
        "regione_id": 13
      },
      "id": 146,
      "label": "SARDEGNA-CAGLIARI"
    },
    {
      "provinciaObject": {
        "id": "UD",
        "label": "Udine",
        "regione_id": 18
      },
      "id": 147,
      "label": "FRIULI - UDINE"
    },
    {
      "id": 149,
      "label": "LAZIO-TIVOLI"
    },
    {
      "provinciaObject": {
        "id": "RO",
        "label": "Rovigo",
        "regione_id": 9
      },
      "id": 150,
      "label": "VENETO-ROVIGO"
    },
    {
      "provinciaObject": {
        "id": "SR",
        "label": "Siracusa",
        "regione_id": 1
      },
      "id": 151,
      "label": "SICILIA - SIRACUSA"
    },
    {
      "provinciaObject": {
        "id": "PR",
        "label": "Parma",
        "regione_id": 11
      },
      "id": 152,
      "label": "EMILIA - PARMA"
    },
    {
      "provinciaObject": {
        "id": "EN",
        "label": "Enna",
        "regione_id": 1
      },
      "id": 153,
      "label": "SICILIA-ENNA"
    },
    {
      "provinciaObject": {
        "id": "MN",
        "label": "Mantova",
        "regione_id": 10
      },
      "id": 154,
      "label": "LOMBARDIA - MANTOVA"
    },
    {
      "provinciaObject": {
        "id": "SO",
        "label": "Sondrio",
        "regione_id": 22
      },
      "id": 155,
      "label": "LOMBARDIA-SONDRIO"
    },
    {
      "provinciaObject": {
        "id": "SS",
        "label": "Sassari",
        "regione_id": 13
      },
      "id": 156,
      "label": "SARDEGNA - SASSARI"
    },
    {
      "provinciaObject": {
        "id": "AT",
        "label": "Asti",
        "regione_id": 2
      },
      "id": 157,
      "label": "PIEMONTE - ASTI"
    }
  ]
function refreshListini (company: Azienda, component: FormAziendaComponent | ProgettoComponent ){
  company['ProdottiListino'] = [];
  company['CategorieListino'] = [];
  company['ListiniObject'] = [];
  var Api = component['apiPath'] ?? component['apiPaths'];
  company['listini']?.forEach(
    listino => {
      Api.ClassicPost('/prodotti/promozione/get', {id:listino}).subscribe(data => {

        const ListinoObject = {...data?.data, label: `${data?.data.nome}, dal ${dateTimeStringToFormattedDate(data.data.data)} al ${dateTimeStringToFormattedDate(data?.data.data_fine)}`};
        company['ListiniObject'].push(ListinoObject);
        Api.ClassicPost('/prodotti/promozione/prodotti/list', {page: 0, size: 200, id:listino, tipo: 'C'}).subscribe(
          catgorie=>
            company['CategorieListino'] = [...company['CategorieListino'], ...catgorie?.data?.map(x=> {return {...x, listino: ListinoObject, voce_id: x.id, id: listino}})]
        )
        Api.ClassicPost('/prodotti/promozione/prodotti/list', {page: 0, size: 200, id:listino, tipo: 'P'}).subscribe(
          prodotti=>
            company['ProdottiListino'] = [...company['ProdottiListino'], ...prodotti?.data?.map(x=> {return {...x, listino: ListinoObject, voce_id: x.id, id: listino}})]
        )
      })
    }
  )
  Api.ClassicGet('/anagrafica/clienti/promozioni').subscribe(
    CatComPromozioni=>
    {
      company.tipiObject.forEach(
        tipo => {
          CatComPromozioni.find(x=>x.id==tipo.id)['listini']?.forEach(
            listino => {
              Api.ClassicPost('/prodotti/promozione/get', {id:listino}).subscribe(data => {
                const ListinoObject = {...data?.data, label: `${data?.data.nome}, dal ${dateTimeStringToFormattedDate(data.data.data)} al ${dateTimeStringToFormattedDate(data?.data.data_fine)}`};
                company['ListiniObject'].push(ListinoObject);
                Api.ClassicPost('/prodotti/promozione/prodotti/list', {page: 0, size: 200, id:listino, tipo: 'C'}).subscribe(
                  catgorie=>
                    company['CategorieListino'] = [...company['CategorieListino'], ...catgorie?.data?.map(x=> {return {...x, listino: ListinoObject, voce_id: x.id, id: listino}})]
                )
                Api.ClassicPost('/prodotti/promozione/prodotti/list', {page: 0, size: 200, id:listino, tipo: 'P'}).subscribe(
                  prodotti=>
                    company['ProdottiListino'] = [...company['ProdottiListino'], ...prodotti?.data?.map(x=> {return {...x, listino: ListinoObject, voce_id: x.id, id: listino}})]
                )
              })
            }
          )
        }
      )
    }
  )

}
var PaymentMethods = (paymentMethods, permission: Permission) => {
  if (permission.isOperativeRoles(['K'])) return [
    {id: 38, nome: "BONIFICO BANCARIO ANTICIPATO", codice: "BBA", deleted_at: null},
    {id: 4, nome: "ASSEGNO A VISTA", codice: "ASS", deleted_at: null},
    {id: 148, nome: "RIMESSA DIRETTA 60 GG FM", codice: "RD60", deleted_at: null},
    {id: 72, nome: "RI.BA 60 GG F.M.", codice: "RB02", deleted_at: null},
  ];
  if (permission.isOperativeRoles(['AG'])) return [
    {id: 38, nome: "BONIFICO BANCARIO ANTICIPATO", codice: "BBA", deleted_at: null},
  ];
  return paymentMethods;
}

function ClientiTipizzati  () : EnvironmentModel{
  return {
    Menu: [
      {
        module: "Clienti",
        title: 'Aziende',
        class: "has-arrow",
        path: "/listautenti/aziende",
        icon: "mdi mdi-account-multiple",
        capacita: ["menu-clienti"],
        show:(component: VerticalSidebarComponent)=>{return component.permission.isntOperativeRoles(['S','DM','NAM']) && component.permission.isntAccessRoles([26])},
        submenu:[
          {
            module: "Clienti",
            path: "/listautenti/aziende/c?tipoSocieta=SO",
            title: 'Società',
            icon: "mdi mdi-account-multiple",
            capacita: ["menu-clienti"],
          },
          {
            module: "Clienti",
            path: "/listautenti/aziende/c?tipoSocieta=DI",
            title: 'Ditte Individuali',
            icon: "mdi mdi-account-multiple",
            capacita: ["menu-clienti"],
          },

          {
            module: "Clienti",
            path: "/listautenti/aziende/C?tipoSocieta=E",
            title: 'Clienti Estero',
            icon: "mdi mdi-account-multiple",
            capacita: ["menu-clienti"],
            notruoliOperativi: ["K"],
          },
          {
            module: "Clienti",
            path: "/listautenti/aziende/C?tipoSocieta=P",
            title: 'Privati',
            icon: "mdi mdi-account-multiple",
            capacita: ["menu-clienti"],
            notruoliOperativi: ["K", "AG"],
          },
          {
            module: "Clienti",
            path: "/listautenti/aziende/C?tipoSocieta=CI",
            title: 'Clienti Inbev',
            icon: "mdi mdi-account-multiple",
            capacita: ["menu-clienti"],
            notruoliOperativi: ["K", "AG"],
          },
          {
            module: "Clienti",
            path: "/listautenti/aziende/K",
            title: 'Key Account',
            icon: "mdi mdi-account-multiple",
            capacita: ["menu-clienti"],
            notruoliOperativi: ["K", "AG"],
          },
          {
            module: "Clienti",
            path: "/listautenti/aziende/C?tipoSocieta=",
            title: 'Tutte le Aziende',
            icon: "mdi mdi-account-multiple",
            capacita: ["menu-clienti"],
            notruoliOperativi: ["K"],
          },
        ]
      },


    ],
    ClientiAddOn:{
      sharedQueryString: true,
      map:(company, bup, component: FormAziendaComponent | ListaAziendeComponent | ProgettoComponent)=>{

        switch (company.tipoSocieta ) {
          case 'E':
           company.lingua = 'IN'
            if(company.nazioneObject) {
              company.catCont = intraUeCountries.includes(company.nazioneObject.codice)? 'UE' : 'EST';
              company.zona = company.nazioneObject.zone?.find(x=>true)?.id;
            }
          break;
          case 'SO':
            company.lingua = 'IT'
            company.nazione = 'ITA'
            company.catCont = 'ITA'
            if(company.tipi.includes(2) || company.tipi.includes(50)) {
              company.grOutput = '001'
            }
            if(company.provinciaObject){

              company.zona = Zone?.find(x=> x.provinciaObject?.id == company.provinciaObject?.id )?.id;
              company.regione = company.provinciaObject.regione_id;
            }
            break;
          case 'DI':
            company.lingua = 'IT'
            company.nazione = 'ITA'

            company.catCont = 'ITA'
            if(company.tipi.includes(2) || company.tipi.includes(50)) {
              company.grOutput = '001'
            }
            if(company.provinciaObject){
              company.zona = Zone?.find(x=> x.provinciaObject?.id == company.provinciaObject?.id )?.id;
              company.regione = company.provinciaObject.regione_id;
            }
            break;
          case 'P':
            company.lingua = 'IT'
            company.nazione = 'ITA'
            company.catCont = 'ITA'
            if(company.tipi.includes(2) || company.tipi.includes(50)) {
              company.grOutput = '001'
            }
            company.codice_univoco = "0000000"
            if(company.provinciaObject){
              company.zona = Zone?.find(x=> x.provinciaObject?.id == company.provinciaObject?.id )?.id;
              company.regione = company.provinciaObject.regione_id;
            }
            break;
          case 'CI':
            company.lingua = 'IT'
            company.nazione = 'ITA'
            company.catCont = 'ITA'
            company.tipi = [1];
            if(company.provinciaObject){
              company.zona = Zone?.find(x=> x.provinciaObject?.id == company.provinciaObject?.id )?.id;
              company.regione = company.provinciaObject.regione_id;
            }
            break;
        }
        if((company.tipoSocieta == 'SO' || company.tipoSocieta == 'DI' || company.tipoSocieta == 'E') && !company.id) {
          company.checkAmm = true;
        }
        //company.ruoli = ['C'];
        if(!company.ruoliAccessoObject?.length)
        company.ruoliAccesso = [company.ruoli.includes('C') ? 14 : 20]
        else
          company.ruoliAccesso = company.ruoliAccessoObject.map(x=>x.id)
        console.log(company);
        return company;
      },
      onChange: (item:{ OnChange: string; Event: any }, component: FormAziendaComponent )=>{
        if(item.OnChange == 'OnlistiniChange' && component.selected?.id){
          refreshListini(component.selected, component)
        }
      },
      initialize: (company: Azienda, component: FormAziendaComponent )=>{
         if(!company?.id) return company;
         // if(!company['listini']?.length)
         //  refreshListini(company, component)
         return company;
      },
      SezioniInfo: [

        {
          sezione: 'Anagrafica',

          // titleStyle: { 'font-weight': "700", 'padding': '0.8rem', 'background-color': 'whitesmoke' },
          campi: [
            {

              nome: 'Società/Ditta individuale',
              oggetti: ['tipoSocieta'],
              modificabile: true,

              source: [{id: 'SO', label: 'SOCIETA'}, {id: 'DI', label: 'DITTA INDIVIDUALE'}, {id:'P', label: 'PRIVATO'}, {id:'E', label: 'ESTERO'}, {id:'CI', label: 'CLIENTI INBEV'}],
              internalOutput: 'tipoSocietaObject',
              OutputField: 'tipoSocieta',
              OnChange: 'tipoSocietachange',
              inputType: 'singleDropdown',
              placeholder: 'Seleziona',
              settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: true,
                idField: 'id',
                textField: 'label',
                searchPlaceholderText: "Cerca",
                allowSearchFilter: true,
                allowRemoteDataSearch: false,
              },

              class: 'col-lg-3',
              visibleifProhibited: true,
              nextDivClass: 'col-lg-12'
            },
            CampoAggiuntivo.TextField("Ragione sociale", "nominativo"),
            CampoAggiuntivo.TextField("Indirizzo", "indirizzo"),
            CampoAggiuntivo.TextField("CAP", "cap"),
            CampoAggiuntivo.TextField("Città", "citta"),
            CampoAggiuntivo.SingleDropdown("Nazione", "nazione", "/anagrafica/clienti/nazioni", "nome", {
              settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: true,
                idField: 'codice',
                textField: "nome",
                searchPlaceholderText: "Cerca",
                allowSearchFilter: true,
                allowRemoteDataSearch: false,
              },
              hideif: {func: (company) => {return ['E'].includes(company['tipoSocieta'])}},
              responseMap: (data,permission)=>{
                var user = JSON.parse(localStorage.getItem('currentUser'));
                return data.filter(x=>!(user['nazioni']?.length >0) || user['nazioni']?.findIndex(y => y == x.codice) > -1 )
              },
            }),
            CampoAggiuntivo.SingleDropdown("Provincia", "provincia", "/settings/province", "label", {
              settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: true,
                idField: 'id',
                textField: "label",
                searchPlaceholderText: "Cerca",
                allowSearchFilter: true,
                allowRemoteDataSearch: false,
              },
              responseMap: (data,permission)=>{
                var user = JSON.parse(localStorage.getItem('currentUser'));
                return data.filter(x=>!(user['regioni']?.length >0) || user['regioni']?.findIndex(y => y == x.regione_id) > -1 )
              },
              hideif: {func: (company) => {return !['E'].includes(company['tipoSocieta'])}},
            }),
            {...CampoAggiuntivo.TextField("P.IVA / Vat", "piva"), hideif:{func: (company) => {return ['SO', 'E', 'DI'].includes(company['tipoSocieta'])}}},
            {...CampoAggiuntivo.TextField("Codice fiscale", "cf", 'col-lg-3'), hideif:{func: (company) => {return ['P', 'DI', 'SO'].includes(company['tipoSocieta'])}}},
            {...CampoAggiuntivo.TextField("Email", "email"), inputType: "email"},
            {...CampoAggiuntivo.TextField("SDI", "codice_univoco"), hideif:{func: (company) => {return [ 'DI', 'SO'].includes(company['tipoSocieta'])}}},
            {...CampoAggiuntivo.TextField("Pec", "pec"), inputType:"email",  hideif:{func: (company) => {return [ 'DI', 'SO'].includes(company['tipoSocieta'])}}},
            CampoAggiuntivo.TextField("Telefono", "telefono"),
            CampoAggiuntivo.TextField("Cellulare", "fax"),
            CampoAggiuntivo.SingleDropdown("Tipologia", "tipi", "/anagrafica/clienti/types", "nome", {
              hideif: {func: (company) => {return !['CI'].includes(company['tipoSocieta'])}},
              settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: false,
                idField: 'id',
                textField: "label",
                searchPlaceholderText: "Cerca",
                allowSearchFilter: true,
                allowRemoteDataSearch: false,
              },
              responseMap: (data,permission)=>{
                var user = JSON.parse(localStorage.getItem('currentUser'));
                return data.filter(x=>!(user['catCom']?.length >0) || user['catCom']?.findIndex(y => y == x.id) > -1 )
              },
              //responseMap: (data,permission)=>{return permission.isOperativeRole('AG') ? data.filter(x=> x['codice'] == 43 || x['codice'] == 1 || x['codice'] == 48) ?? [] : data}
            })

          ]
        },
        {
          sezione: 'Rischio',
          hideif: {func: (company) => {return company.codAdhoc}},
          campi: [
            {
              prevDivClass: 'col-12',
              modificabile: false,
              nome: 'Fido aziendale:',
              oggetti: ['fido'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              visibleifProhibited: true,
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
            },
            {
              modificabile: false,
              nome: 'Fido Assicurativo:',
              oggetti: ['fidoAmm'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']},
              visibleifProhibited: true,
            },
            {
              modificabile: false,
              nome: 'Partite Aperte (escl.effetti):',
              oggetti: ['partiteAperte'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              visibleifProhibited: true,
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
            },
            {
              modificabile: false,
              nome: 'Partite Aperte Provv. (escl.effetti):',
              oggetti: ['partiteAperteProv'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              visibleifProhibited: true,
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
            },
            {
              modificabile: false,
              nome: 'Effetti in scadenza:',
              oggetti: ['effettiScadenza'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              visibleifProhibited: true,
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
            },
            {
              modificabile: false,
              nome: 'Effetti scaduti:',
              oggetti: ['effettiScaduti'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              visibleifProhibited: true,
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
            },
            {
              modificabile: false,
              nome: 'Partite Scadute:',
              oggetti: ['fattureScadute'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              visibleifProhibited: true,
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
            },
            {
              modificabile: false,
              nome: 'Ordini in essere:',
              oggetti: ['ordiniEssere'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              visibleifProhibited: true,
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
            },
            {
              modificabile: false,
              nome: 'DDT non fatturati:',
              oggetti: ['ddtNonFatturati'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              visibleifProhibited: true,
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
            },
            {
              modificabile: false,
              nome: 'Fatture non contabilizzate:',
              oggetti: ['fattureNonCont'],
              inputType: 'text',
              type: 'string',
              titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
              titleClass: 'control-label col-form-label',
              class: 'col-12',
              inputStyle: {font: 'message-box', 'font-size': '20px'},
              visibleifProhibited: true,
              hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
            },
            // {
            //   nome: 'Sconto 1 %',
            //   oggetti: ['sconto1'],
            //   modificabile: true,
            //   inputType: 'number',
            //   class: "col-lg-2",
            //   hideif: {hasRoles: ['AG', 'K']}
            // },
            // {
            //   nome: 'Sconto 2 %',
            //   oggetti: ['sconto2'],
            //   modificabile: true,
            //   inputType: 'number',
            //   class: "col-lg-2",
            //   hideif: {hasRoles: ['AG', 'K']}
            // },
            // {
            //   nome: 'Sconto 3 %',
            //   oggetti: ['sconto3'],
            //   modificabile: true,
            //   inputType: 'number',
            //   class: "col-lg-2",
            //   hideif: {hasRoles: ['AG', 'K']}
            // },
          ]
        },
        {
          sezione: "Pagamento",
          campi:[
            CampoAggiuntivo.SingleDropdown("Pagamento", "pagamento", "/progetti/progetti/pagamenti", "nome", {
              responseMap: (data, permission) => {
                return PaymentMethods(data, permission)
              }
            }),
            {
              nome: 'Coordinate Bancarie (iban)',
              oggetti: ['iban'],
              modificabile: true,
              class: 'col-lg-3',
            },
            {
              nome: 'Descrizione',
              oggetti: ['banca'],
              modificabile: true,
              class: 'col-lg-3',
            },
            {
              nome: 'Iva',
              oggetti: ['iva'],
              modificabile: true,
              class: 'col-lg-3',
              hideif:{hasNotRoles: ['SA']}
            },
            CampoAggiuntivo.SingleDropdown("Agente", "agente", "/anagrafica/clienti/agenti", "nome", {
              disabledif: {hasRoles: ['K', 'AG']},
              hideif: {hasRoles: ['AG','K']}
            }),
            {
              modificabile: true,
              nome: 'KeyAccount',
              oggetti: ['keyaccount'],
              inputType: 'singleDropdown',
              source: '/anagrafica/clienti/list',
              parameter: [{nome: "page", value: 1}, {nome: "size", value: 2000}, {nome: "ruolo", value: "K"}],
              responseHasData: true,
              OutputField: 'keyaccount',
              internalOutput: 'keyaccountObject',
              placeholder: 'Seleziona',
              OnChange: 'OnkeyaccountChange',
              hideif: { func:(x, permission)=>{return ['SO', 'DI'].includes(x.tipoSocieta) && permission.isntOperativeRoles(['AG', 'K'])}},
              settings: {
                singleSelection: false,
                closeDropDownOnSelection: false,
                singleOutput: false,
                idField: 'id',
                textField: 'nominativo',
                allowSearchFilter: true,
              },
              class: 'col-lg-3',
              visibleifProhibited: true
            },
            CampoAggiuntivo.SingleDropdown("Gestore", "id_segnalatore_interno", "/anagrafica/persone/list", "fullName", {
              responseHasData:true,
              parameter: [{nome: "page", value: 1}, {nome: "size", value: 2000}],
            }),
            {...CampoAggiuntivo.TextField("Note", "note", "col-12"), inputType:"textarea"}
          ]
        },
        {
          sezione: 'Listini',
          campi:[
            CampoAggiuntivo.SingleDropdown("Listino Base", "listinoBase", "/anagrafica/clienti/listini", "nome", {
              settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: true,
                idField: 'codice',
                textField: "nome",
                searchPlaceholderText: "Cerca",
                allowSearchFilter: true,
                allowRemoteDataSearch: false,
              },
            }),
            {
              modificabile: true,
              nome: 'Listini',
              oggetti: ['listini'],
              inputType: 'singleDropdown',
              source: '/prodotti/promozione/list',
              parameter: [{nome: "page", value: 1}, {nome: "size", value: 2000}],
              responseHasData: true,
              OutputField: 'listini',
              internalOutput: 'listiniObject',
              placeholder: 'Seleziona',
              OnChange: 'OnlistiniChange',
              hideif: {hasRoles: [ 'K']},
              disabledif: {hasRoles: [ 'AG','K']},
              settings: {
                singleSelection: false,
                closeDropDownOnSelection: false,
                singleOutput: false,
                idField: 'id',
                textField: 'nome',
                allowSearchFilter: true,
              },
              titleClass: 'control-label col-form-label',
              class: 'col-lg-3',
              visibleifProhibited: true
            },
            {
              type: 'table',
              nome: 'Listini',
              oggetti: ['ListiniObject'],
              class:'col-12',
              hideif: {hasRoles: [ 'K']},
              modificabile:true,
              azioni:[
                {
                  edit: true,
                  onlyUpdate: true,
                  hideif:{hasRoles: [ 'AG','K']},
                  ExternalSave: false,
                  CrudSettings: ListinoPromozione(),
                  icon: 'fa-pencil-alt',
                  tooltip: 'Modifica il listino',
                  color: 'blue'
                },
                {
                  edit: true,
                  onlyUpdate: true,
                  ExternalSave: false,
                  CrudSettings: {...ListinoPromozione(), DisableEdit:true},
                  icon: 'fa-eye',
                  tooltip: 'Visualizza il listino',
                  color: 'blue'
                },
              ],
              header:[
                {nome: 'Listino / Promozione', modificabile:false, oggetti: ['nome'], inputType: 'text'},
                {nome: 'Tipo', modificabile: false, oggetti: ['tipo'], type:'replace', replacement: [{original: 'L', replace: 'Listino'}, {original: 'P', replace: 'Promozione'}]},
                {nome: 'Inizio', modificabile: false, oggetti: ['data'], inputType: 'date'},
                {nome: 'Fine', modificabile: false, oggetti: ['data_fine'], inputType: 'date'},
              ]

            }
          ]
        },
        {
          sezione: 'Listini (Dettaglio Visibile SOLO come SA)',
          hideif: {hasNotRoles: ['SA']},
          campi: [
            {
              type:'table',
              collapsable: true,
              collapsed: false,
              nome:'Prodotti:',
              oggetti:['ProdottiListino'],
              class:'col-12',
              modificabile:true,
              azioni:[
                {
                  edit: true,
                  onlyUpdate: true,
                  ExternalSave: false,
                  CrudSettings: ListinoPromozione(),
                  icon: 'fa-pencil-alt',
                  tooltip: 'Modifica il listino',
                  color: 'blue'
                },
              ],
              header:[
                ...ProdottiTable().header?.map(x=>({...x, modificabile:false, source: x.source != '/prodotti/list'? x.source : []})),
                {nome: 'Listino', modificabile:false, oggetti: ['listino.label'], inputType: 'text'},
              ]
            },
            {
              type:'table',
              collapsable: true,
              collapsed: false,
              nome:'Categorie:',
              oggetti:['CategorieListino'],
              class:'col-12',
              modificabile:true,
              azioni:[
                {
                  edit: true,
                  onlyUpdate: true,
                  ExternalSave: false,
                  CrudSettings: ListinoPromozione(),
                  icon: 'fa-pencil-alt',
                  tooltip: 'Modifica il listino',
                  color: 'blue'
                },
              ],
              header:[

                ...CategorieTable().header?.map(x=>({...x, modificabile:false})),
                {nome: 'Listino', modificabile:false, oggetti: ['listino.label'], inputType: 'text'},
              ]
            }
            // {
            //   type: 'table',
            //   nome: 'Listini',
            //   oggetti: ['listini'],
            //
            // }
          ]
        },
        {
          sezione: "Utenza",
          campi: [
            {...CampoAggiuntivo.TextField("Email Account", "emailAccount"), disabledif:{hasRoles: ['K', 'AG']}},
            {...CampoAggiuntivo.TextField("username", "username"), disabledif:{ hasRoles: ['K', 'AG']}},
            {...CampoAggiuntivo.TextField("Password", "password"), hideif:{func:(x, permission: Permission)=>{ return (permission.isntOperativeRoles(['AG', 'K'])) || permission.IAmYourFather()}}, inputType: "password"},
            {...CampoAggiuntivo.TextField("Conferma Password", "conferma_password"), inputType: "password", hideif:{func:(x, permission: Permission)=>{ return ( permission.isntOperativeRoles(['AG', 'K'])) || permission.IAmYourFather()}}},
            CampoAggiuntivo.SingleDropdown("Ruoli", 'ruoliAccesso', '/anagrafica/ruoli/list', 'label', {
              hideif: {func:(x,permission:Permission)=>permission.IAmYourFather()},
              parameter: [],
              responseHasData:true,
              settings: {
                singleSelection: false,
                closeDropDownOnSelection: false,
                singleOutput: false,
                selectIfSingle:true,
                idField: 'id',
                textField: 'ruolo',
                allowSearchFilter: true,
               // excludeIds:[19,22,17,13,12,21,15,16,18]
              },
            }),
            {...CampoAggiuntivo.TextField("Inviato", "inviato", "col-lg-3"), inputType:"checkbox", disabledif: {hasNotRoles: ['SA']}},
            {...CampoAggiuntivo.TextField("Check Amministrativo", "checkAmm"), inputType:"checkbox", disabledif: {hasRoles: ['K', 'AG']}}


          ]
        },
        ...SezioniSanpellegrino
      ]
    }

  };
}

export var Environment = () => {
  var env: EnvironmentModel = {
    Wp: false,
    translateSettings: true,
    IDTecnico: "RT",
    IDCliente: "C",
    IDAdmin: "AZ",
    IDRoot: "SA",
    ClientiType: ['CA', 'C', 'AC'],
    filtrife: [],
    legenda: [],
    production: true,
    apiUrl: 'https://customer.klimaitalia.it/api',
    bbbUrl: 'https://newsbs.ddns.net/bigbluebutton',
    langPrefix: './assets/i18n/',
    langSuffix: '.json',
    ClientebaseUrl: '/Cliente/formazienda/c/',
    baseUrl: '/progetti/progetti?evasioni=0',
    href: '/Login',
    homepages: [
      {Ruoli: ["AC"], link: "/Cliente/profile"},
      {RuoliAccesso: [26], link: "/sanpellegrino/shared/dynamiclist/clienti"},
      {Ruoli: ["S", "DM"], link:"/sanpellegrino/shared/dynamiclist/assegna"},
      {Ruoli: ["NAM"], link:"/sanpellegrino/shared/dynamiclist/clienti"},
      {Ruoli: ["AG", "K"], link: "/progetti/ordini/k"},
      {RuoliAccesso: [13], link: "/progetti/progetti?evasioni=0"},
      {RuoliAccesso: [12], link: "/progetti/prodotti/lista"},
      {RuoliAccesso: [21], link: "/sanpellegrino/shared/dynamiclist/brandizzazioni"},
    ],
    //#region Layout Config
    logoPath: 'assets/images/Klima_noclaim_bgw.png',
    loginMsg: '',
    loginbgPath: 'assets/images/klimasede.jpeg',
    icon: 'assets/images/klima-favicon.png',
    logoBg: 'skin1', // six possible values: skin(1/2/3/4/5/6),
    navbarbg: 'skin2', // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: 'skin1', // six possible values: skin(1/2/3/4/5/6)
    userCircleColor: "",
    theme: 'light',
    dir: 'ltr', // two possible values: ltr, rtl
    layout: 'vertical', // fixed value. shouldn't be changed.
    sidebartype: 'full', // four possible values: full, iconbar, overlay, mini-sidebar
    sidebarpos: 'fixed', // two possible values: fixed, absolute
    headerpos: 'fixed', // two possible values: fixed, absolute
    boxed: 'full', // two possible values: full, boxed
    //#endregion
    //#region Moduli
    Modules: {
      "twoFactorAuth": false,
      "Admin": true,
      "Personale": true,
      "Clienti": true,
      "Interventi": false,
      "Prima_Nota": false,
      "Listini": false,
      "Progetti": true,
      "Prodotti": true,
      "Documenti": true,
      "Scadenzario": false,
      "Spedizioni": false,
      "Stampe": true,
      "Task": true,
      "Shared": false,
      "Dashboard": true,
      "Settings": true,
      "Formazione": false,
      "VersioneCarbotti": false,
      "PartiProdotto": false,
      "Parti": false,
      "Rma": true,
      "Ecommerce": true,
      "ScadenzeFiglie": false,
      "Registrazione": false,
      "Ticket": true,
      "Acquisti": false,
      "taskboard": false,
      "Camera": false,
      "Valutazioni": false
    },
    //#endregion
    //#region Addon
    CategorieAddon: {
      Sources: [
        {
          nome: 'Categorie filtri',
          tipo: 'P',
          restroute: '/prodotti/dettagli/cat',
          type: 'POST',
          param: {},
          valori: true,
          color: false,
          cat_image: false
        },
      ],
    },
    DashboardAddon: [
      {
        url: '/progetti/progetti/dashboard',
        initObj: [
          {campo: 'anno', value: AnnoCorrente()},
          {campo: 'trimestre', value: 'A'},
        ],
        filters: [
          {
            nome: 'Anno:',
            oggetti: ['anno'],
            modificabile: true,
            inputType: 'numeric',
            class: 'col-lg-3',
            OnChange: 'refresh'
          },
          {
            nome: "Periodo",
            source: [{id: 'A', label: 'Anno intero'}, {id: "1", label: "Primo Trimestre"}, {
              id: "2",
              label: "Secondo Trimestre"
            }, {id: "3", label: "Terzo Trimestre"}, {id: "4", label: "Quarto Trimestre"}],
            oggetti: ['cSomministrazioni'],
            internalOutput: 'trimestreObject',
            OutputField: 'trimestre',
            modificabile: true,
            OnChange: 'refresh',
            inputType: 'singleDropdown',
            placeholder: "Seleziona",
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'label',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false,
            },
            class: 'col-lg-3',
            visibleifProhibited: true
          },
        ],
        campi: [
          {nome: "Ordini", tipo: "text", oggetto: "num_offerte", larghezza: 'col-lg-3', class: 'bg-info'},
          {nome: "Ordini chiusi", tipo: "text", oggetto: "num_offerte_chiuse", larghezza: 'col-lg-3', class: 'bg-info'},
          {nome: "€ Ordini", tipo: "text", oggetto: "ordini", class: 'bg-info', larghezza: 'col-lg-3'},
          {nome: "€ Ordini chiusi", tipo: "text", oggetto: "ordini_chiusi", larghezza: 'col-lg-3', class: 'bg-info'},
        ]
      }
    ],
    Personale: {
      Corsi: true,
      regioni: true,
      campiAggiuntivi: [
        {
          modificabile: true,
          nome: 'Agente Adhoc',
          oggetti: ['agente'],
          inputType: 'singleDropdown',
          source: '/anagrafica/clienti/agenti',
          internalOutput: 'agenteObject',
          OutputField: 'agente',
          placeholder: 'Seleziona',
          OnChange: 'OnAgenteChange',
          hideif: {hasRoles: ['AG']},
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'nome',
            allowSearchFilter: true,
          },
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          visibleifProhibited: true
        },
        CampoAggiuntivo.SingleDropdown("Nazione", "nazioni", "/anagrafica/clienti/nazioni", "nome", {
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: false,
            idField: 'id',
            textField: "nome",
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false,
          },
          hideif: {hasRoles: ['AG']},
        }),
        CampoAggiuntivo.SingleDropdown("Categoria Commerciale", "catCom", "/anagrafica/clienti/types", "nome", {

          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: false,
            idField: 'id',
            textField: "label",
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false,
          },
          hideif: {hasRoles: ['AG']},
          responseMap: (data,permission)=>{return permission.isOperativeRole('AG') ? data.filter(x=> x['codice'] == 43 || x['codice'] == 1 || x['codice'] == 48) ?? [] : data}
        })
      ]
    },
    PartiAddOn: [false],//  categorie associate
    TaskAddon: {
      checkList: false,
      DynamicFields: [{
        type: 'N',
        addButton: true,
        hideif: {hasNotCapacity: ['gestione-news']},
        restRoute: '/task/news',
        Label: 'News',
        Azioni: [
          {
            nome: 'Anteprima',
            close: false,
            class: ' btn ',
            labelClass: 'ml-1 text-info font-weight-bold',
            type: 'GOTO_BLANK',
            restRoute: `https://www.klimaitalia.it/prodotti/area_riservata/newsdetails/:id/it/:token`,
            capacita: ['gestione-news'],
            icon: 'fas fa-eye text-info',
            placeholder: 'Anteprima',
            hideif: {fieldnotexist: 'id'}
          },
          {
            nome: 'Aggiungi Tutti i clienti',
            close: false,
            class: ' btn ',
            labelClass: 'ml-1 text-info font-weight-bold',
            type: 'AddAllCatCom',
            capacita: ['gestione-news'],
            icon: 'fas fa-plus text-info',
            placeholder: 'Aggiungi Titti i clienti'
          },
          {
            nome: 'Invia Notifiche',
            class: ' btn ',
            labelClass: 'ml-1 text-orange font-weight-bold',
            type: 'POST',
            restRoute: '/task/news/send',
            capacita: [],
            icon: 'fas fa-plane text-orange',
            placeholder: 'Invia Notifiche ai Clienti',
            successMex: "Notifiche inviate",
            hideif: {fieldnotexist: 'id'},
            parameter: [{nome: "ids", parameter: 'clienti'}, {nome: 'news', parameter: 'id'}]
          },
          {
            nome: 'Elimina',
            close: true,
            class: ' btn ',
            labelClass: 'ml-1 text-danger font-weight-bold',
            type: 'POST',
            restRoute: '/task/news/delete',
            preAlert: 'Sei sicuro di voler eliminare questo elemento?',
            capacita: ['gestione-news'],
            icon: 'fas fa-trash text-danger',
            hideif: {fieldnotexist: 'id'},
            placeholder: 'Elimina',
            successMex: 'Elemento eliminato con successo',
            parameter: [{nome: "id", parameter: 'id'}]
          },
        ],
        campi: [
          {nome: 'Titolo:', oggetti: ['nome'], modificabile: true, inputType: 'text', class: 'col-lg-12'},
          {nome: 'Body:', oggetti: ['note'], inputType: 'blackhtml', modificabile: true, class: 'col-lg-12'},
          {nome: 'Data:', oggetti: ['data_inizio_prevista'], modificabile: true, inputType: 'date', class: 'col-lg-3'},
          {
            nome: 'Data Fine:',
            oggetti: ['data_fine_prevista'],
            modificabile: true,
            inputType: 'date',
            class: 'col-lg-3'
          },
          {nome: 'Publica:', oggetti: ['publicata'], modificabile: true, inputType: 'checkbox', class: 'col-lg-3'},
          {
            type: 'image',
            oggetti: ['id_immagine'],
            imageToServer: 'immagine',
            filename: 'file',
            titleClass: 'control-label col-form-label',
            class: 'col-md-12',
            visibleifProhibited: true,
            modificabile: true
          },
          {
            prevDivClass: 'col-lg-12',
            modificabile: true,
            nome: 'Aggiungi Clienti',
            oggetti: ['addclienticatcom'],
            inputType: 'singleDropdown',
            source: '/anagrafica/clienti/promozioni',
            internalOutput: 'addCatCom',
            OnChange: "AddCatCom",
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'nome',
              allowSearchFilter: true,
            },
            titleClass: 'control-label col-form-label',
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            nome: 'Clienti Aggiunti',
            collapsable: true,
            collapsed: true,
            oggetti: ['clientiObject'],
            type: "table",
            header: [{nome: "Cliente", oggetti: ['nominativo']}],
            modificabile: true,
            class: 'col-lg-12',
            azioni: [{ExternalOnClick: 'OnDelete', icon: 'fa-trash', tooltip: 'Elimina', color: 'red'}]
          },

        ]
      }]
    },
    ClientiAddOn: {
      filters: [
        {nome: "Cerca", oggetti: ["nome"], modificabile: true, inputType: "text"},
        {nome: "Non in Adhoc", oggetti: ["noAdhoc"], modificabile: true, type: "boolean", inputType: "checkbox"},
        {nome: "Da Abilitare", oggetti: ["abilita"], modificabile: true, type: "boolean", inputType: "checkbox"},
        {nome: "Ordina per data", oggetti: ["orderByData"], modificabile: true, type: "boolean", inputType: "checkbox"},
      ],
      headers: [
        {nome: "Nominativo", oggetti: ["nominativo"]},
        {nome: "Adhoc", oggetti: ["codAdhoc"]},
        {nome: "Data di registrazione", oggetti: ["dataRegistrazione"], inputType: "datetime-local"},
      ],
      codAdhoc: true,
      SendToAdhoc: true,
      alertInfoMancanti: [
        {nome: "Indirizzo", field: 'indirizzo', mex: "l'indirizzo non è stato inserito"},
        {nome: "Telefono", field: 'telefono', mex: "il numero di Telefono non è stato inserito"},
      ],
      enable: true,
      info: true,
      iva: true,
      commerciale: false,
      segnalatore: false,
      segnalatoreInterno: true,
      sedi: true,
      TipoSedePrimaria: false,
      emailAccount: true,
      attivita: false,
      geolocalizzazione: true,
      ruolo: true,
      Modifica: false,
      prodotti: false,
      rma: false,
      cf: true,
      codice_univoco: true,
      accesso: true,
      referenti: true,
      interventi: false,
      note_private: false,// rende invisibile il campo note al cliente
      rating: true,
      ruoliAccesso: true,
      compilazione: false,
      luogoNascita: false,
      dataNascita: false,
      statoCivile: false,
      titoloStudio: false,
      occupazione: false,
      invalidita: false,
      legge104: false,
      diagnosi: false,
      accompagnamento: false,
      pensione: false,
      tutelare: false,
      medico: false,
      scontoAdhoc: true,
      telMedico: false,
      terapia: false,
      checkAmm: true,
      provinciaArray: true,
      referentiInInfo: true,
      validate: (company, component: FormAziendaComponent | ListaAziendeComponent, isAdhoc?: boolean, isForce?:boolean) => {
        console.log("validate", company)

        const requiredFieldK: { text: string, param: string }[] = [
          {text: 'Ragione Sociale', param: 'nominativo'},
          {text: 'Tipo Società', param: 'tipoSocieta'},
          {text: 'Indirizzo', param: 'indirizzo'},
          {text: 'CAP', param: 'cap'},
          {text: 'Città', param: 'citta'},
          {text: 'Nazione', param: 'nazione'},
          {text: 'Tipo Societa', param: 'tipoSocieta'},
          // {text: 'Provincia', param: 'provincia'},
          {text: 'E-Mail', param: 'email'},
          {text: 'Telefono', param: 'telefono'},
          // {text: 'Pagamento', param: 'pagamento'},
          // {text: 'Zona', param: 'zona'},
          {text: 'Ruoli', param: 'ruoli'},
        ];

        if(!company['pagamento']) {
          requiredFieldK.push({text: 'Pagamento', param: 'pagamento'});
        }
        if(company['tipoSocieta'] != 'CI' && !company['zona']) {
          requiredFieldK.push({text: 'Zona', param: 'zona'});
        }
        if ((company['tipoSocieta'] == 'DI' || company['tipoSocieta'] == 'P' )&& !company['cf']) {
          requiredFieldK.push({text: 'Codice Fiscale', param: 'cf'});
        }
        // if (!company['tipi']?.length) {
        //   requiredFieldK.push({text: 'Tipologia', param: 'tipi'});
        // }
        if(company['tipoSocieta'] != 'E' && !company['provincia']){}

        var UnsettedField: { text: string, param: string }[] = requiredFieldK.filter(campo => !company[campo.param]);
        if (['SO', 'E'].includes(company['tipoSocieta']) && !company['piva']) {
          UnsettedField.push({text: 'Partita Iva', param: 'piva'});
        }
        if(['E', 'SO', 'DI', 'P'].includes(company['tipoSocieta']) && !company['id_segnalatore_interno']){
          UnsettedField.push({text: 'Gestore', param: 'id_segnalatore_interno'});
        }
        if ((company['tipoSocieta'] == 'DI' || company['tipoSocieta'] == 'P' )&& !company['cf']) {
          UnsettedField.push({text: 'Codice Fiscale', param: 'cf'});
        }
        if (!company['tipi']?.length && isAdhoc) {
          UnsettedField.push({text: 'Tipologia', param: 'tipi'});
        }
        if(company['tipoSocieta'] != 'E' && !company['provincia']){
          UnsettedField.push({text: 'Provincia', param: 'provincia'});
        }
        if(isAdhoc && !company['listinoBase']){
          UnsettedField.push({text: 'Listino Base', param: 'listinoBase'});
        }
        if (!company['pec'] && !company['codice_univoco'] && company['tipoSocieta'] != 'P' && company['tipoSocieta'] != 'E' && company['tipoSocieta'] != 'CI') {
          UnsettedField.push({text: 'Pec', param: 'pec'});
        }
        if(isAdhoc && !company['agente'] && company['tipoSocieta'] != 'CI'){
          UnsettedField.push({text: 'Agente', param: 'agente'});
        }
        if(isAdhoc && !company['catCont']){
          UnsettedField.push({text: 'Categoria Contabile', param: 'catCont'});
        }


        if (company['pagamento'] != 38 && (!company['iban'] || !company['banca']) && !isAdhoc) {
          UnsettedField.push({text: 'Coordinate Bancarie (iban)', param: 'iban'});
          UnsettedField.push({text: 'Descrizione', param: 'banca'});
        }
        if ((!component.permission.isOperativeRoles(['K', 'AG']) && !isAdhoc) || !UnsettedField?.length || (component.permission.isOperativeRoles(['SA']) && isForce)) return true
        var text = UnsettedField?.length == 1 ? `Il campo ${UnsettedField.map(unsetted => unsetted.text).join(", ")} è richiesto` : `I campi ${UnsettedField.map(unsetted => unsetted.text).join(", ")} sono richiesti`
        component.toastservice.error(text);
        console.log("Validation Error: ", text, UnsettedField, company);
        return false;
      },
      CampiAggiuntivi: [
        CampoAggiuntivo.SingleDropdown("Gr. Output", "grOutput", [{
          id: "001",
          label: "Rivenditori ITALIA"
        }], "label", {}),
        CampoAggiuntivo.SingleDropdown("Nazione", "nazione", "/anagrafica/clienti/nazioni", "nome", {
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'codice',
            textField: "nome",
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false,
          },
        }),
        CampoAggiuntivo.SingleDropdown("Categoria Contabile", "catCont", "/anagrafica/clienti/catcont", "nome", {
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'codice',
            textField: "nome",
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false,
          },
        }),
        CampoAggiuntivo.SingleDropdown("Listino Base", "listinoBase", "/anagrafica/clienti/listini", "nome", {
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'codice',
            textField: "nome",
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false,
          },
        }),
        {
          nome: 'Cellulare',
          oggetti: ['fax'],
          modificabile: true,
          class: 'col-lg-3',
        },
        {
          prevDivClass: 'col-12',
          modificabile: false,
          nome: 'Fido disponibile:',
          oggetti: ['fido'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
        },
        {
          modificabile: false,
          nome: 'Fido Assicurativo:',
          oggetti: ['fidoAmm'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']},
          visibleifProhibited: true,
        },
        {
          modificabile: false,
          nome: 'Partite Aperte:',
          oggetti: ['partiteAperte'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
        },
        {
          modificabile: false,
          nome: 'Partite Aperte Provv:',
          oggetti: ['partiteAperteProv'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
        },
        {
          modificabile: false,
          nome: 'Effetti in scadenza:',
          oggetti: ['effettiScadenza'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
        },
        {
          modificabile: false,
          nome: 'Effetti scaduti:',
          oggetti: ['effettiScaduti'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
        },
        {
          modificabile: false,
          nome: 'Partite Scadute:',
          oggetti: ['fattureScadute'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
        },
        {
          modificabile: false,
          nome: 'Ordini in essere:',
          oggetti: ['ordiniEssere'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
        },
        {
          modificabile: false,
          nome: 'DDT non fatturati:',
          oggetti: ['ddtNonFatturati'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
        },
        {
          modificabile: false,
          nome: 'Fatture non contabilizzate:',
          oggetti: ['fattureNonCont'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K'], fieldnotexist: ['id']}
        },
        {
          nome: 'Sconto 1 %',
          oggetti: ['sconto1'],
          modificabile: true,
          inputType: 'number',
          class: "col-lg-2",
          hideif: {hasRoles: ['AG', 'K']}
        },
        {
          nome: 'Sconto 2 %',
          oggetti: ['sconto2'],
          modificabile: true,
          inputType: 'number',
          class: "col-lg-2",
          hideif: {hasRoles: ['AG', 'K']}
        },
        {
          nome: 'Sconto 3 %',
          oggetti: ['sconto3'],
          modificabile: true,
          inputType: 'number',
          class: "col-lg-2",
          hideif: {hasRoles: ['AG', 'K']}
        },
        //{ nome: 'Codice Fiscale', oggetti: ['cf'], modificabile: true, inputType: 'text' },
        {
          prevDivClass: 'col-12',
          nome: 'Coordinate Bancarie (iban)',
          oggetti: ['iban'],
          modificabile: true,
          class: 'col-lg-3',
        },
        {
          nome: 'Descrizione',
          oggetti: ['banca'],
          modificabile: true,
          class: 'col-lg-3',
        },
        CampoAggiuntivo.SingleDropdown("Pagamento", "pagamento", "/progetti/progetti/pagamenti", "nome", {
          responseMap: (data, permission) => {
            return PaymentMethods(data, permission)
          }
        }),
        {
          prevDivClass: 'col-12',
          modificabile: true,
          nome: 'KeyAccount',
          oggetti: ['keyaccount'],
          inputType: 'singleDropdown',
          source: '/anagrafica/clienti/list',
          parameter: [{nome: "page", value: 1}, {nome: "size", value: 2000}, {nome: "ruolo", value: "K"}],
          responseHasData: true,
          OutputField: 'keyaccount',
          internalOutput: 'keyaccountObject',
          placeholder: 'Seleziona',
          OnChange: 'OnkeyaccountChange',
          hideif: {hasRoles: ['K', 'AG']},
          settings: {
            singleSelection: false,
            closeDropDownOnSelection: false,
            singleOutput: false,
            idField: 'id',
            textField: 'nominativo',
            allowSearchFilter: true,
          },
          class: 'col-lg-3',
          visibleifProhibited: true
        },
        CampoAggiuntivo.SingleDropdown("Zona", "zona", "/settings/zone", "label", {}),
        CampoAggiuntivo.SingleDropdown("Lingua", "lingua", "/anagrafica/clienti/lingue", "label", {}),
        CampoAggiuntivo.SingleDropdown("Agente", "agente", "/anagrafica/clienti/agenti", "nome", {
          disabledif: {hasRoles: ['K', 'AG']},
          hideif: {hasRoles: ['AG','K']}
        }),
        {

          nome: 'Società/Ditta individuale',
          oggetti: ['tipoSocieta'],
          modificabile: true,

          source: [{id: 'SO', label: 'SOCIETA'}, {id: 'DI', label: 'DITTA INDIVIDUALE'}, {id:'P', label: 'PRIVATO'}, {id:'E', label: 'ESTERO'}, {id:'CI', label: 'CLIENTI INBEV'}],
          internalOutput: 'tipoSocietaObject',
          OutputField: 'tipoSocieta',
          OnChange: 'tipoSocietachange',
          inputType: 'singleDropdown',
          placeholder: 'Seleziona',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'label',
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false,
          },
          class: 'col-lg-3',
          visibleifProhibited: true
        },
      ]
    },
    ProdottiAddOn: {
      shortDescription: true,
      classeEnergetica: true,
      export: true,
      logo: true,
      toggleOrdinamentoProdoti: true,
      tags: true,
      updated_at: true,
      video: true,
      dettaglio: true,
      files: true,
      cart: true,
      codice: false,
      codice_produttore: false,
      tipo: true,
      standby: true,
      fuoriProduzione: true,
      tipi: true, // tipi di prodotto (1 - 2ante klima)
      cat_image: true,
      lista_prezzo: true,
      TranslatedDesc: true,
      codAdhoc: true,
      periodoNew: true,
      DragSort: true,
      cat_Sort: true,
      sottoTitolo: true,
      rifornimento: false,
      created_at: true,
      prodottiCorrelati: true,
      CategoriaSingola: false,
      keyaccount: true,
      CampiAggiuntivi: [
        {nome: 'Brandizzare', oggetti: ['brandizzare'], modificabile: true, inputType: 'checkbox', class: 'col-lg-2'},
        {
          nome: 'prodotti.pesoVolume',
          oggetti: ['pesoVolume'],
          modificabile: true,
          inputType: 'number',
          class: 'col-lg-3'
        },
        {
          nome: 'Descrizione Stampa',
          oggetti: ['descrizioneStampa'],
          modificabile: true,
          inputType: 'textarea',
          class: 'col-lg-6'
        },
        CampoAggiuntivo.SingleDropdown("Prodotto Sostitutivo", "sostituto", "/prodotti/list", "prodotto", {
          parameter: [{nome: "page", value: 1}, {nome: "size", value: 2000}],
          responseHasData: true,
        }),
        CampoAggiuntivo.TableField(
          "Accessori",
          [CampoAggiuntivo.TextField("Nome", "prodotto", "col-12", {modificabile:false})],
          "ricambiObject",
          true,
          'col-lg-12',
          {
            azioni:[
              {
                type:'func',
                icon: 'fas fa-trash',
                tooltip:'elimina',
                func:(x,CampoAggiuntivo, CampoPadre, Padre, apiPaths: ApiPathsService, component)=>{
                  Padre.ricambiObject.splice(Padre.ricambiObject.findIndex(y=>y==x), 1);
                }
              }
            ],
            AzioniTask :[
              {
                nome: 'Aggiungi',
                close: false,
                icon: 'fas fa-plus text-info',
                class: ' btn ',
                CrudSettings:{ HasGet: false,},
                noRefresh:true,
                labelClass: 'text-info font-weight-bold',
                type: 'edit',
                campi: [
                  CampoAggiuntivo.SingleDropdown("Accessori", "accessorio","/prodotti/list","prodotto",{
                    parameter:[{nome: "page", value:0}, {nome: "size", value:10}, {nome:'tipo', value: 69} ],
                    responseHasData:true,
                  }, "col-lg-3", ()=>true, {selectIfSingle:false}),

                ],
                customSave:(tsk, api, Item, data, component: DynamicCrudService)=>{
                  if(!tsk.ricambiObject) tsk.ricambiObject = [];
                  tsk.ricambiObject.push({...tsk.accessorioObject, posizione: "Posizione" })

                }
              },

            ],
          }
        )

      ],
      SezioniCodiciSconto:[
        {
          sezione: '',
          campi:[
            CampoAggiuntivo.TextField("Nome", "prodotto"),
            {
              type:'image',
              oggetti:['id_immagine'],
              imageToServer: 'immagine',
              filename: 'file',
              titleClass: 'control-label col-form-label',
              class: 'col-md-12',
              visibleifProhibited: true,
              modificabile: true
            },
          ]
        }
      ],
      prodottiFilter: [
        {nome: "Cerca", oggetti: ['prodotto'], type: "text", class: 'col-lg-9'},
        {nome: "Inizio", oggetti: ['inizio'], inputType: "date", class: 'col-lg-4', prevDivClass: 'col-12'},
        {nome: "Fine", oggetti: ['fine'], inputType: "date", class: 'col-lg-4'},
        {
          nome: 'Fuori Produzione',
          oggetti: ['fuoriProduzione'],
          modificabile: true,
          source: [
            {id: null, label: 'Tutti'},
            {id: true, label: 'Fuori Produzione'},
            {id: false, label: 'In Produzione'}
          ],
          OutputField: 'fuoriProduzione',
          internalOutput: 'fuoriProduzioneObject',
          inputType: 'singleDropdown',
          placeholder: 'Seleziona stato',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'label'
          },
          class: 'col-lg-12'
        }
      ]
    },
    CalendarAddon: {
      managerScadenza: false,
    },
    ProgettiAddon: {
      commerciale: false,
      segnalatore: false,
      categoriaVoceDiCosto: false,
      lavorato: false,
      OggettoNascosto: true,
      HideColore: true,
      HidePrezzo: false,
      gestore: true,
      costoSpedizione: true,
      personalizzazioni: true,
      destinazioni: true,
      inviaEmail: true,
      scontoAdhoc: true,
      HideIvato: true,
      pagato: true,
      keyaccount: true,
      sottoOfferte: true,
      sottoOfferteView: 'tab',
      onChange: (progetto, item, component )=>{
        if(item.OnChange == 'onClienteChange' && progetto.clienteObject && !progetto.clienteObject['ListiniObject']){
          component.apiPath.ClassicPost('/anagrafica/clienti/get', {id:progetto.clienteObject.id}).subscribe(data => {
            progetto.clienteObject = data;

            refreshListini(progetto.clienteObject, component);
            component.apiPath.ClassicGet('/anagrafica/clienti/nazioni').subscribe(nazioni=>{
             var nonUeCountries = nazioni.map(x=>x.codice).filter(x=>!intraUeCountries.includes(x))
              if(nonUeCountries.includes(data.nazione)) {
                console.log('non UE')
              }
            })
          })
        }
      },
      initialize: (progetto, component )=>{
        return progetto;
      },
      onSaveMap: async (progetto: any, InitialValue: Progetto, toast: ToastrService, permission: Permission, component: ProgettoComponent) => {

        if(progetto.clienteObject?.nazione != 'ITA' && progetto.clienteObject?.nazione != 'IT' && progetto.clienteObject?.nazione ){
          console.log("Cliente: ",progetto.clienteObject)
          console.log("Non Nazionale, Calcolo Origine Pref...")
          var Prodotti: any[] = [];
          progetto.progetti?.forEach(sottop => {
            if(!sottop.voci?.find(x=>x.costo_id == 30))
            sottop.voci.forEach(async voce => {
              Prodotti.push({prodotto: voce.prodotto_id, voce: voce});
            })
          });
          var productGet = Prodotti.filter(x=>x.prodotto)?.map(x=> component.apiPath.ClassicPost('/prodotti/get', {id: x.prodotto}))
          var prodotti = await forkJoin(productGet).toPromise()
          console.log(prodotti);



          progetto.progetti?.forEach(sottop => {
            var Origini: any[] = [];
            sottop.voci.forEach(async voce=>{
              var prod = prodotti.find(x=>x.id == voce.prodotto_id)
              if(prod?.origine != null)
                Origini.push(prod?.origine);
            })
            if(Origini.length && !sottop.voci?.find(x=>x.costo_id == 30))
              sottop.voci.push({
                "costo_id": 30,
                "prodotto_id": null,
                "voce": "Origine preferenziale dei prodotti:\n"+ Origini.join('\n'),
                "quantita": 1,
                "prezzo": 0.00,
                "umSelezionabili": [
                  {
                    "id": 64,
                    "label": "pz"
                  }
                ],
                "um": [
                  {
                    "id": 64,
                    "label": "pz"
                  }
                ],
                "um_id": 64,
                "iva": 22,
                "modifica": false,
                "um_list": [
                  {
                    "id": 64,
                    "label": "pz"
                  }
                ],
                "prezzi": [],
                "disponibilitaMagazzino": [
                  ""
                ],
                "magazzino": null
              })
          });
         }
      },
      ValidateProgetto: (progetto: any, InitialValue: Progetto, toast: ToastrService, permission: Permission) => {

        var valido = InitialValue?.data_conferma || !progetto?.data_conferma || progetto?.francoDeposito || (progetto?.data_conferma && progetto?.progetti?.every(x => x?.francoDeposito || x?.voci?.every(y => !y?.prodotto_id || y['spedizione'])));
        if (!valido) {
          toast.warning("Non tutti i prodotti hanno il costo di Trasporto");
          return false;
        }
        if (!InitialValue?.data_conferma && progetto.data_conferma && progetto.clienteObject['bloccoContenzioso'] && permission.isntOperativeRoles(['K'])) {
          if (!confirm("Il cliente è stato Bloccato per contenzioso. Procedere con l'invio?"))
            return false;
          return confirm("Sicuro di voler inviare l'ordine?");
        }
        return valido;
      },
      canCreateSubOffer: (progetto: Progetto, permission: Permission, env) => {
        return progetto && !permission.isOperativeRoles(['K', 'AG']); //&& progetto?.progetti?.some(x => !x.data_conferma);
      },
      PaymentMethods: PaymentMethods,
      TotaliAggiuntivi: (component: VociDiCostoComponent) => {
        const tocalc = component.myProp?.voci?.filter(x => !parseFloat(x?.spedizione?.toString()??'0') && x.prodotto_id && x.quantita > 0 );
        const setted = component.myProp?.voci?.filter(x => parseFloat(x?.spedizione?.toString()??'0'));
        if( !tocalc?.length || (!component.myProp.provincia && !component.myProp.consegna?.provincia) ){
          console.log("Totali Aggiuntivi: No data to calculate");
          return;
        }


        const requests = tocalc.map(voce =>
          component.apiPaths.ClassicPost("/prodotti/trasporto", {
            id: voce.prodotto_id,
            provincia: component.myProp?.consegna?.provincia ?? component.myProp?.provincia,
            trasporto: component.Cliente['trasporto'],
            qta: voce.quantita
          }).pipe(map(x => {
            return {data: x, voce: voce}
          }))
        );

        forkJoin(requests).subscribe((results: { data: any[], voce: {quantita: number, iva:number,} }[]) => {
          console.log("Results: ",results);
          component.TotaliAggiuntivi = [];
          let Trasporto = 0;
          let Iva = 0;

          results.forEach(data => {
            var price = 0;
            if(component.isCostiPerRegione(data.data) && data.data.length && data.data[0].prezzi?.length  ){
              price = parseFloat(data.data[0].prezzi[data.data[0].prezzi.length - 1].toString()) * data.voce.quantita;
            }else if (component.isCostiPerMagazzino(data.data) && data.data.length && data.data[0].prezzi?.length  && data.data[0].prezzi[0].prezzi?.length   ){
              price = parseFloat(data.data[0].prezzi[0].prezzi[data.data[0].prezzi[0].prezzi.length - 1].toString())* data.voce.quantita;
            }
            Trasporto += price;
            Iva += CalcIva(price, data.voce.iva ?? 22);
          });

          component.TotaliAggiuntivi = [
            ...(component.TotaliAggiuntivi ?? []),
            {
              label: setted?.length ? "Costo Trasporto Residuo Previsto" : "Costo Trasporto Previsto",
              netto: Trasporto,
              iva: Iva,
              info: "Il costo di trasporto verrà calcolato alla conferma dell'ordine"
            }
          ];
          console.log("TotaliAggiuntivi: ",component.TotaliAggiuntivi);
        });
      },
      VociColumn: (Progetti, filter, item, permission: Permission) => {
        return filter.prodotto || permission?.isOperativeRoles(['AG', 'K']);
      },
      CampiAggiuntivi: [ // campi aggiuntiv voci di costo
        {
          nome: 'Descrizione',
          oggetti: ['descFuorimagazzino'],
          modificabile: true,
          inputType: 'textarea',
          hideif: {
            func: (x, permission: Permission) => {
              return x.costo_id == 28 && permission.isntOperativeRoles(['AG', 'K'])
            }
          }
        },
        {
          nome: 'Descrizione',
          oggetti: ['descFuorimagazzino'],
          modificabile: true,
          inputType: 'text',
          hideif: {
            func: (x, permission: Permission) => {
              return x.costo_id != 28 && permission.isntOperativeRoles(['AG', 'K'])
            }
          },
        },
        {
          nome: 'Sconto %',
          oggetti: ['sconto'],
          modificabile: true,
          inputType: 'number',
          MathOperation: {MathType: '-', NumType: 'percentage'},
          hideif: {hasRoles: ['AG', 'K']},
        },
        {
          nome: 'Sconto %',
          oggetti: ['sconto2'],
          modificabile: true,
          inputType: 'number',
          MathOperation: {MathType: '-', NumType: 'percentage'},
          hideif: {hasRoles: ['AG', 'K']},
        },
        {
          nome: 'Sconto %',
          oggetti: ['sconto3'],
          modificabile: true,
          inputType: 'number',
          MathOperation: {MathType: '-', NumType: 'percentage'},
          hideif: {hasRoles: ['AG', 'K']},
        },
        {
          nome: 'Trasporto €',
          oggetti: ['spedizione'],
          modificabile: true,
          inputType: 'number',
          MathOperation: {MathType: '+', NumType: 'number'},
          hideif: {hasRoles: ['AG', 'K']},
        },
        {
          nome: 'Trasporto €',
          oggetti: ['spedizione'],
          modificabile: false,
          inputType: 'number',
          hideif: {hasNotRoles: ['AG', 'K']},
        },
        {
          nome: 'Disponibilità',
          oggetti: ['disponibilitaMagazzino'],
          type: 'Array',
          field: ['magazzino', 'disponibilita'],
          modificabile: false,
          inputType: 'number',
          hideif: {hasRoles: ['AG', 'K']},
        },
        {
          nome: 'Disponibilità',
          oggetti: ['disponibilitaProdotto'],
          modificabile: false,
          inputType: 'number',
          hideif: {hasNotRoles: ['AG', 'K']},
        },
        {
          nome: 'Merce in Arrivo',
          oggetti: ['materasso'],
          modificabile: false,
          inputType: 'number',
          hideif: {hasRoles: ['AG', 'K']},
        },
        // {nome:'Data Merce in Arrivo', oggetti:['dataMaterasso'], modificabile: false, inputType: 'date'},
        {
          nome: 'Magazzino',
          oggetti: ['magazzino'],
          modificabile: true,
          source: [{id: '00001', label: 'NOCI'}, {id: '00005', label: 'UDINE'}, {id: '00009', label: 'SANPELLEGRINO NOCI'}, {id: '00010', label: 'SANPELLEGRINO UDINE'}],
          OutputField: 'magazzino',
          internalOutput: 'magazzinoObject',
          inputType: 'singleDropdown',
          placeholder: 'Seleziona',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'label',
          },
          visibleifProhibited: true,
          hideif: {hasRoles: ['AG', 'K']},
        },
        {
          nome: 'Data Evas. Prev.',
          oggetti: ['dataConsegna'],
          modificabile: true,
          inputType: 'date',
          hideif: {hasRoles: ['AG', 'K']},
        },
        {
          nome: 'Lavorare',
          oggetti: ['brandizzare'],
          modificabile: true,
          inputType: 'checkbox',
          hideif: {hasRoles: ['AG', 'K']},
        },
        {
          nome: 'Lavorato',
          oggetti: ['brandizzato'],
          modificabile: true,
          inputType: 'checkbox',
          hideif: {hasRoles: ['AG', 'K'],}
        },
        {
          nome: 'In evasione',
          oggetti: ['evasione'],
          modificabile: true,
          inputType: 'checkbox',
          hideif: {hasRoles: ['AG', 'K']},
        },

      ],
      CampiAggiuntiviLista: [
        {nome: 'Offerta.Conferma', oggetti: ['data_conferma'], type: 'date'},
        {nome: 'CO Adhoc', oggetti: ['codiceOrdineAdhoc'], type: 'text'},
        {
          nome: '', oggetti: [''], type: 'func', func: (item: Progetto) => {
            if (item.data_conferma) {
              return '';
            }
            var data = new Date();
            data.setDate(data.getDate() - 5);
            var sub: Progetto[] = item.progetti?.filter(item => !item.data_conferma) ?? [];
            if (sub?.some(sottop => sottop?.voci?.some(v => v['dataDisponibilita'] && new Date(v['dataDisponibilita']) > data && v['disponibilitaProdotto'] > 0))) {
              return 'Ordine con prodotti tornati disponibili';
            }
            return '';
          }
        },
      ],
      filters: [
        {
          nome: 'Offerta.Codice',
          oggetti: ['codice'],
          modificabile: true,
          inputType: 'text',
          class: 'col-lg-9',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
        },
        {
          nome: 'Prodotto', oggetti: ['prodotto'], modificabile: true, inputType: 'text', class: 'col-lg-9',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
        },
        {
          nome: 'Annullati', oggetti: ['annullati'], modificabile: true, inputType: 'checkbox', class: 'col-lg-3',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
        },
        CampoAggiuntivo.SingleDropdown("Ordini con prodotti tornati disponibili", "disponibili", [{
          id: true,
          label: "Disponibili"
        }, {id: false, label: "Non Disponibili"}], 'label', {
          class: 'col-lg-12',
          titledivClass: 'input-group-prepend',
          titleClass: 'input-group-text',
        }),
      ],
      Revisioni: true,
      tipoPagamento: true,
      banche: true,
      francoDeposito: true,
      ColoriLista: [
        {colore: "#ff0000", campo: "data_creazione", label: "Ordine da Lavorare"},
        {colore: "#9d9800", campo: "data_emissione", label: "Ordine in attesa di accettazione"},
        {colore: "#0000ff", campo: "data_accettazione", label: "Ordine confermato dal cliente"},
        {colore: "#7979ff", campo: "data_conferma", label: "Ordine inviato in adhoc"},
        {colore: "#eecc00", campo: "annullato", label: "Ordine annullato"}
      ],
      CampiNuovoCliente: [
        {
          nome: 'cliente.nominativo',
          prevDivClass: "col-12",
          required: true,
          oggetti: ['nominativo'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'cliente.piva',
          required: true,
          oggetti: ['piva'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'cliente.pec',
          required: false,
          oggetti: ['pec'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'cliente.codice_univoco',
          required: true,
          oggetti: ['codice_univoco'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'cliente.email',
          required: true,
          oggetti: ['email'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'cliente.indirizzo',
          required: true,
          oggetti: ['indirizzo'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'cliente.cap',
          required: true,
          oggetti: ['cap'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'cliente.citta',
          required: true,
          oggetti: ['citta'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'cliente.provincia',
          required: true,
          oggetti: ['provincia'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'cliente.telefono',
          required: true,
          oggetti: ['telefono'],
          modificabile: true,
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3'
        },
        {
          nome: 'Società/Ditta individuale',
          oggetti: ['tipoSocieta'],
          modificabile: true,

          source: [{id: 'SO', label: 'SOCIETA'}, {id: 'DI', label: 'DITTA INDIVIDUALE'}],

          internalOutput: 'tipoSocietaObject',
          OutputField: 'tipoSocieta',
          OnChange: 'tipoSocietachange',
          required: true,
          inputType: 'singleDropdown',
          placeholder: 'Seleziona',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'label',
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false,
          },
          class: 'col-lg-3',
          visibleifProhibited: true
        },
        {nome: 'Codice Fiscale', required: true, oggetti: ['cf'], modificabile: true, inputType: 'text'},
        {
          nome: 'Coordinate Bancarie',
          oggetti: ['iban'],
          required: true,
          modificabile: true,
        },
      ],
      CampiOfferta: [
        {
          prevDivClass: 'col-12',
          modificabile: false,
          nome: 'Ragione Sociale:',
          oggetti: ['clienteObject'],
          field: ['nominativo'],
          inputType: 'text',
          type: 'object',
          hideif: {fieldnotexist: 'clienteObject'},
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
        },
        {
          modificabile: false,
          nome: 'Indirizzo:',
          oggetti: ['clienteObject'],
          field: ['indirizzo'],
          hideif: {fieldnotexist: 'clienteObject'},
          inputType: 'text',
          type: 'object',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
        },
        {
          modificabile: false,
          nome: 'Cap:',
          oggetti: ['clienteObject'],
          hideif: {fieldnotexist: 'clienteObject'},
          field: ['cap'],
          inputType: 'text',
          type: 'object',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
        },
        {
          modificabile: false,
          nome: 'Città:',
          oggetti: ['clienteObject'],
          hideif: {fieldnotexist: 'clienteObject'},
          field: ['citta'],
          inputType: 'text',
          type: 'object',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
        },
        {
          modificabile: false,
          nome: 'Provincia:',
          oggetti: ['clienteObject'],
          hideif: {fieldnotexist: 'clienteObject'},
          field: ['provincia'],
          inputType: 'text',
          type: 'object',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
        },
        {
          modificabile: false,
          nome: 'Partita IVA:',
          oggetti: ['clienteObject'],
          hideif: {fieldnotexist: 'clienteObject'},
          field: ['piva'],
          inputType: 'text',
          type: 'object',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
        },
        {
          modificabile: false,
          nome: 'Codice AdHoc:',
          oggetti: ['clienteObject'],
          hideif: {fieldnotexist: 'clienteObject'},
          field: ['codAdhoc'],
          inputType: 'text',
          type: 'object',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
        },
        {
          modificabile: false,
          nome: 'Telefono:',
          oggetti: ['clienteObject'],
          hideif: {fieldnotexist: 'clienteObject'},
          field: ['telefono'],
          inputType: 'text',
          type: 'object',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
        },
        {
          modificabile: false,
          nome: 'E-mail:',
          oggetti: ['clienteObject'],
          hideif: {fieldnotexist: 'clienteObject'},
          field: ['email'],
          inputType: 'text',
          type: 'object',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-9',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
        },
        {
          prevDivClass: 'col-12',
          modificabile: false,
          nome: 'Fido Disponibile:',
          oggetti: ['fido'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K']},
        },
        {
          modificabile: false,
          nome: 'Fatture Scadute:',
          oggetti: ['fattureScadute'],
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {
            func: (x, permission: Permission) => {
              return x.fattureScadute && permission.isntOperativeRoles(['K']);
            }
          },
        },
        {
          modificabile: false,
          nome: 'Fido Assicurativo:',
          oggetti: ['fidoAssicurativo'],
          OnChange: 'OnFidoAssicurativoChange',
          inputType: 'text',
          type: 'string',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K']},
        },
        {
          modificabile: false,
          nome: 'Partite Aperte:',
          type: 'object',
          oggetti: ['clienteObject'],
          field: ['partiteAperte'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K']}
        },
        {
          modificabile: false,
          nome: 'Partite Aperte Provv:',

          oggetti: ['clienteObject.partiteAperteProv'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K']}
        },
        {
          modificabile: false,
          nome: 'Effetti in scadenza:',
          oggetti: ['clienteObject.effettiScadenza'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K']}
        },
        {
          modificabile: false,
          nome: 'Effetti scaduti:',
          oggetti: ['clienteObject.effettiScaduti'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K']}
        },
        // {
        //   modificabile: false,
        //   nome: 'Partite Scadute:',
        //   oggetti: ['fattureScadute'],
        //   inputType: 'text',
        //   type: 'string',
        //   titleStyle: { 'font-size': 'medium', 'margin-right': '5px' },
        //   titleClass: 'control-label col-form-label',
        //   class: 'col-md-3',
        //   inputStyle: { font: 'message-box', 'font-size': '20px' },
        //   visibleifProhibited: true,
        //   hideif: { hasRoles: ['AG', 'K'] }
        // },
        {
          modificabile: false,
          nome: 'Ordini in essere:',
          oggetti: ['clienteObject.ordiniEssere'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K']}
        },
        {
          modificabile: false,
          nome: 'DDT non fatturati:',
          oggetti: ['clienteObject.ddtNonFatturati'],

          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K']}
        },
        {
          modificabile: false,
          nome: 'Fatture non contabilizzate:',
          oggetti: ['clienteObject.fattureNonCont'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          inputStyle: {font: 'message-box', 'font-size': '20px'},
          visibleifProhibited: true,
          hideif: {hasRoles: ['K']}
        },
        {
          modificabile: false,
          nome: 'Listini / promozioni:',
          type: 'Array',
          oggetti: ['clienteObject.ListiniObject'],
          field: ['label'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          inputStyle: {font: 'message-box', 'font-size': '18px'},
          azioni:[
            {
              edit: true,
              onlyUpdate: true,
              ExternalSave: false,
              CrudSettings: {...ListinoPromozione(), DisableEdit:true},
              icon: 'fa-eye',
              tooltip: 'Visualizza il listino',
              color: 'blue'
            },
          ] ,

          class: 'col-md-6',
          hideif: {hasRoles: ['K']}
        },
        {
          modificabile: false,
          nome: 'Note:',
          oggetti: ['clienteObject.note'],
          inputType: 'text',
          titleStyle: {'font-size': 'medium', 'margin-right': '5px'},
          titleClass: 'control-label col-form-label',
          inputStyle: {font: 'message-box', 'font-size': '18px'},
          class: 'col-md-6',
          hideif: {hasRoles: ['K',"AG"]}
        },
        {
          prevDivClass: 'col-12',
          modificabile: true,
          nome: 'Agente',
          oggetti: ['agente'],
          inputType: 'singleDropdown',
          source: 'Agenti',
          internalOutput: 'agenteObject',
          placeholder: 'Seleziona',
          OnFilter: 'filtroAgente',
          OnChange: 'OnAgenteChange',
          disabledif: {hasRoles: ['AG', 'K']},
          hideif: {hasRoles: ['K']},
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'fullName',
            allowSearchFilter: true,
          },
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          visibleifProhibited: true
        },
        // {
        //   modificabile:true,
        //   nome: 'Offerta.Responsabile',
        //   oggetti: ['manager'],
        //   inputType: 'singleDropdown',
        //   source: 'managers',
        //   internalOutput: 'managerObject',
        //   OnFilter: 'filtroManager',
        //   OnChange: 'OnManagerChange',
        //   placeholder: 'Seleziona',
        //   settings: {
        //     singleSelection: true,
        //     closeDropDownOnSelection: true,
        //     singleOutput:true,
        //     idField: 'id',
        //     textField: 'fullName',
        //     searchPlaceholderText: "inserire almeno 3 caratteri",
        //     allowSearchFilter: true,
        //     allowRemoteDataSearch: true,
        //   },
        //   titleClass: 'control-label col-form-label'  ,
        //   class: 'col-lg-3',
        //   visibleifProhibited: true
        // },
        // {
        //   modificabile:true,
        //   nome: 'cliente.commerciale',
        //   oggetti: ['commerciale'],
        //   inputType: 'singleDropdown',
        //   source: 'managers',
        //   internalOutput: 'commerciale',
        //   OnFilter: 'filtroCommerciale',
        //   placeholder: 'Seleziona',
        //   settings: {
        //     singleSelection: true,
        //     closeDropDownOnSelection: true,
        //     singleOutput:true,
        //     idField: 'id',
        //     textField: 'fullName',
        //     searchPlaceholderText: "inserire almeno 3 caratteri",
        //     allowSearchFilter: true,
        //     allowRemoteDataSearch: true,
        //   },
        //   titleClass: 'control-label col-form-label'  ,
        //   class: 'col-lg-3',
        //   visibleifProhibited: true
        // },{
        //   modificabile:true,
        //   nome: 'cliente.segnalatore',
        //   oggetti: ['clienti'],
        //   inputType: 'singleDropdown',
        //   source: 'clienti',
        //   internalOutput: 'segnalatore',
        //   OnFilter: 'filtrosegnalatore',
        //   placeholder: 'Seleziona',
        //   settings: {
        //     singleSelection: true,
        //     closeDropDownOnSelection: true,
        //     singleOutput: true,
        //     idField: 'id',
        //     textField: 'nominativo',
        //     searchPlaceholderText: "inserire almeno 3 caratteri",
        //     allowSearchFilter: true,
        //     allowRemoteDataSearch: true,
        //     noDataAvailablePlaceholderText:"Nessun Cliente trovato ",
        //     moreButton: true,
        //     moreButtonText: "Cerca in AdHoc",
        //   },
        //   titleClass: 'control-label col-form-label'  ,
        //   class: 'col-lg-3',
        //   visibleifProhibited: true
        // },
        {
          modificabile: true,
          nome: 'Gestore',
          oggetti: ['manager'],
          inputType: 'singleDropdown',
          source: 'managers',
          disabledif: {hasRoles: ['AG', 'K']},
          internalOutput: 'gestoreObject',
          OnFilter: 'filtroCommerciale',
          placeholder: 'Seleziona',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'fullName',
            searchPlaceholderText: "inserire almeno 3 caratteri",
            allowSearchFilter: true,
            allowRemoteDataSearch: true,
            excludeIds: [1032, 983]
          },
          hideif: {hasRoles: ['K']},
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Numero Ordine:',
          oggetti: ['codice'],
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-2',
          placeholder: 'Numero Ordine:',
          visibleifProhibited: true,
          prohibitedRoles: ['AG', 'K']
        },
        {
          prevDivClass: "col-md-12",
          modificabile: true,
          nome: 'Offerta.Creazione',
          oggetti: ['data_creazione'],
          inputType: 'date',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Offerta.Offerta',
          oggetti: ['data_emissione'],
          inputType: 'date',
          disabledif: {hasRoles: ['AG', 'K']},
          hideif: {hasRoles: ['K']},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Offerta.Accettazione',
          oggetti: ['data_accettazione'],
          inputType: 'date',
          disabledif: {hasRoles: ['AG', 'K']},
          hideif: {hasRoles: ['K']},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Offerta.Conferma',
          oggetti: ['data_conferma'],
          inputType: 'date',
          disabledif: {hasRoles: ['AG', 'K']},
          hideif: {hasRoles: ['K']},
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'CO',
          oggetti: ['codiceOrdine'],
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
          disabledif: {fieldexist: 'codiceOrdine'},
          hideif: {fieldnotexist: 'codiceOrdine'}
        },
        {
          modificabile: true,
          nome: 'CO AdHoc',
          oggetti: ['codiceOrdineAdhoc'],
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
          disabledif: {fieldexist: 'codiceOrdineAdhoc'},
          hideif: {fieldnotexist: 'codiceOrdineAdhoc'}
        },
        {
          modificabile: true,
          nome: 'Note',
          oggetti: ['note'],
          inputType: 'textarea',
          titleClass: 'control-label col-form-label',
          class: 'col-md-6',
          visibleifProhibited: true
        },
        {
          modificabile: true,
          nome: 'Note Private',
          oggetti: ['note_private'],
          inputType: 'textarea',
          titleClass: 'control-label col-form-label',
          class: 'col-md-6',
          prohibitedRoles: ['AG', 'K'],
          visibleifProhibited: false
        },
        {
          modificabile: true,
          nome: 'Tracking:',
          oggetti: ['tracking'],
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-12',
          placeholder: 'Tracking:',
          visibleifProhibited: true,
          prohibitedRoles: ['AG', 'K']
        },
        {
          modificabile: false,
          nome: 'Preventivo Inviato:',
          oggetti: ['ordineCliente'],
          inputType: 'html',
          titleClass: 'control-label col-form-label',
          class: 'col-lg-12',
          hideif: {fieldnotexist: 'ordineCliente'},
          placeholder: 'Preventivo Inviato',
          visibleifProhibited: true
        },
      ],
      CampiSottoOfferta: [
        {
          modificabile: true,
          nome: 'Bonifico Segnalato',
          hideif: {hasRoles: ['AG', 'K']},
          oggetti: ['dataBonifico'],
          inputType: 'date',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
        },
        {
          modificabile: true,
          nome: 'Data Invio Previsto',
          disabledif: {hasRoles: ['AG', 'K']},
          oggetti: ['data_accettazione'],
          inputType: 'date',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
        },
        {
          modificabile: true,
          nome: 'Data Invio',
          disabledif: {hasRoles: ['AG', 'K']},
          oggetti: ['data_conferma'],
          inputType: 'date',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
        },

        {
          modificabile: true,
          nome: 'Sede',
          oggetti: ['codAdhoc'],
          inputType: 'singleDropdown',
          source: 'sediAdhoc',
          internalOutput: 'sedeObjectAdhoc',
          OnFilter: 'filtroSedeAdhoc',
          OnChange: 'SedeAdhocChange',
          placeholder: 'Seleziona',
          settings: {
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'codAdhoc',
            textField: 'fullAddress',
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false,
          },
          titleClass: 'control-label col-form-label',
          class: 'col-lg-3',
          prevDivClass: 'col-12',
          visibleifProhibited: true
        },

        {
          prevDivClass: 'col-12',
          modificabile: true,
          nome: 'Referente di consegna',
          oggetti: ['consegna'],
          field: ['nominativo'],
          inputType: 'text',
          type: 'object',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
          hideif: {fieldexist: 'sedeObjectAdhoc'}
        },
        {
          modificabile: true,
          nome: 'Indirizzo',
          oggetti: ['consegna'],
          field: ['indirizzo'],
          inputType: 'text',
          type: 'object',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
          hideif: {fieldexist: 'sedeObjectAdhoc'}
        },
        {
          modificabile: true,
          nome: 'CAP',
          oggetti: ['consegna'],
          field: ['cap'],
          inputType: 'text',
          type: 'object',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
          hideif: {fieldexist: 'sedeObjectAdhoc'}
        },
        {
          modificabile: true,
          nome: 'Città',
          oggetti: ['consegna'],
          field: ['citta'],
          inputType: 'text',
          type: 'object',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
          hideif: {fieldexist: 'sedeObjectAdhoc'}
        },
        {
          modificabile: true,
          nome: 'Provincia',
          oggetti: ['consegna'],
          field: ['provincia'],
          inputType: 'text',
          type: 'object',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
          hideif: {fieldexist: 'sedeObjectAdhoc'}
        },
        {
          modificabile: true,
          nome: 'Telefono',
          oggetti: ['consegna'],
          field: ['telefono'],
          inputType: 'text',
          type: 'object',
          titleClass: 'control-label col-form-label',
          class: 'col-md-3',
          visibleifProhibited: true,
        },
        {
          prevDivClass: "col-12",
          modificabile: true,
          nome: 'Check Amministrativo',
          oggetti: ['checkAmm'],
          inputType: 'checkbox',
          titleClass: 'control-label col-form-label',
          class: 'col-md-1',
          visibleifProhibited: false,
          hideif: {hasRoles: ['AG', 'K']},
          prohibitedRoles: ['AG', 'K']
        },
        {
          modificabile: true,
          nome: 'Contrassegno',
          oggetti: ['contrassegno'],
          inputType: 'checkbox',
          OnChange: 'contrassegno',
          titleClass: 'control-label col-form-label',
          class: 'col-md-1',
          visibleifProhibited: false,
          prohibitedRoles: ['AG', 'K']
        },
        {
          modificabile: true,
          nome: 'Porto Franco',
          oggetti: ['portoFranco'],
          inputType: 'checkbox',
          titleClass: 'control-label col-form-label',
          class: 'col-md-1',
          visibleifProhibited: false,
          prohibitedRoles: ['AG', 'K']
        },
        {
          modificabile: true,
          nome: 'Porto Assegnato',
          oggetti: ['portoAssegnato'],
          inputType: 'checkbox',
          titleClass: 'control-label col-form-label',
          class: 'col-md-1',
          visibleifProhibited: false,
          prohibitedRoles: ['AG', 'K']
        },
        {
          modificabile: true,
          nome: 'Annullato:',
          oggetti: ['annullato'],
          inputType: 'checkbox',
          titleClass: 'control-label col-form-label',
          class: 'col-md-1',
          prohibitedRoles: ['AG', 'K'],
          visibleifProhibited: true,
        },
        {
          modificabile: true,
          nome: 'Data Annullamento:',
          oggetti: ['dataAnnullato'],
          inputType: 'date',
          titleClass: 'control-label col-form-label',
          class: 'col-md-2',
          prohibitedRoles: ['AG', 'K'],
          visibleifProhibited: true,
        },
        {
          modificabile: true,
          nome: 'Riferimento ordine cliente N.:',
          oggetti: ['rifOrdine'],
          inputType: 'text',
          titleClass: 'control-label col-form-label',
          class: 'col-md-2',
          visibleifProhibited: true,
        },
        {
          modificabile: true,
          nome: 'del:',
          oggetti: ['rifData'],
          inputType: 'date',
          titleClass: 'control-label col-form-label',
          class: 'col-md-2',
          visibleifProhibited: true,
        },
      ],
      TipiProgetto: [
        {
          nome: 'Key Account',
          id: "k",
          colore: "#1baa03",
          restRoute: "/progetti/progetti/key",
          capacita: []
        },
      ],
    },
    RmaAddOn: {
      taskGenerico: false,
      vociDiCosto: true,
      provaAcquisto: true,
      CategoriaProdotto: true,
      TipoAcquisto: true,
      TipoAcquistoSource: "ClientiType",
      Rivenditore: true,
      NumeroDocumento: false,
      DataDocumento: true,
      Ricevuta: true,
      Targhetta: true,
      CircostanzaDifetto: true,
      DescrizioneDifetto: false,
      Difetto: true,
      Telefono: false,
      Garanzia: false,
      EstensioneGaranzia: false,
      Allegati: true,
      Modello: true,
      Matricola: true,
      Brand: true,
      sottoTask: true,
      chiuso: true,
      Ritiro: {
        Enabled: true,
        Referente: true,
        Nominativo: true,
        Indirizzo: true,
        Citta: true,
        Cap: true,
        Provincia: true,
        Telefono: true,
        Email: true,
        Chiusura: true,
        Disponibilita: true
      },
      Cliente: {
        Enabled: true,
        Referente: true,
        Nominativo: true,
        Indirizzo: true,
        Citta: true,
        Cap: true,
        Provincia: true,
        Telefono: true,
        Email: true,
        Chiusura: true,
        Disponibilita: true
      },
      Assistenza: {
        Enabled: true,
        Referente: false,
        Nominativo: true,
        Indirizzo: true,
        Citta: true,
        Cap: true,
        Provincia: true,
        Telefono: true,
        Email: true,
        Chiusura: true,
        Disponibilita: true,
        Tecnico: false,
      }
    },
    //#endregion
    //#region Menu
    Menu: [
      {
        module: "Dashboard",
        path: "dashboard/dynamic",
        title: 'menu.dashboard',
        icon: "mdi mdi-gauge",
        capacita: ["menu-dashboard"]
      },
      {
        module: "Task",
        path: "/task/list/N/0/Vertical",
        title: 'News',
        icon: "fas fa-newspaper",
        capacita: ["menu-news"]
      },
      {
        module: "Personale",
        path: "/listautenti/personale",
        title: 'menu.PersonaleLabel',
        icon: "far fa-user",
        capacita: ["menu-persone"]
      },
      // {
      //   module: "Clienti",
      //   path: "/listautenti/aziende",
      //   title: 'menu.clienti',
      //   icon: "mdi mdi-account-multiple",
      //   capacita: ["menu-clienti"],
      //   notruoliOperativi: ["K", "AG"],
      // },
      // {
      //   module: "Clienti",
      //   path: "/listautenti/aziende/c",
      //   title: 'menu.clienti',
      //   icon: "mdi mdi-account-multiple",
      //   capacita: ["menu-clienti"],
      //   ruoliOperativi: ["K", "AG"],
      // },
      {
        module: "Progetti",
        path: "progetti/progetti?evasioni=0",
        title: 'menu.progetti',
        icon: "mdi mdi-calendar-multiple-check",
        capacita: ["menu-progetti"],
        notruoliOperativi: ["AG", "K"],
      },
      {
        module: "Progetti",
        path: "progetti/progetti?evasioni=1&periodo=false&stato_evasione=N",
        title: 'menu.evasioni',
        icon: "mdi mdi-calendar-multiple-check",
        capacita: ["menu-progetti"],
        notruoliOperativi: ["AG", "K"],
      },
      {
        module: "Progetti",
        path: "progetti/ordini/k",
        title: 'menu.progetti',
        icon: "mdi mdi-calendar-multiple-check",
        capacita: ["menu-progetti"],
        ruoliOperativi: ["AG", "K"],
        notruoliOperativi:["S"]
      },
      {
        module: "Progetti",
        path: "progetti/destinazioni",
        title: 'Destinazioni',
        icon: "mdi mdi-airplane-takeoff",
        capacita: ["menu-destinazioni"]
      },
      // {
      //   module: "Task",
      //   path: "task/calendario",
      //   title: 'menu.calendario',
      //   icon: "mdi mdi-calendar",
      // },
      // {
      //   module: "Task",
      //   path: "task/list",
      //   title: 'menu.lista',
      //   icon: "mdi mdi-calendar"
      // },
      {
        module: "Listini",
        path: "listino/listini",
        title: 'menu.listini',
        icon: "fas fa-bars",
        capacita: ["gestione-listino"],
      },
      {
        module: "Acquisti",
        path: "acquisti/acquisti",
        title: 'menu.acquisti',
        icon: "fas fa-cart-plus"
      },
      {
        module: "Acquisti",
        path: "acquisti/lavorazioni",
        title: 'menu.lavorazioni',
        icon: "fab fa-opencart"
      },
      {
        module: "Acquisti",
        path: "acquisti/groupedlavorazioni",
        title: 'menu.groupedlavorazioni',
        icon: "fab fa-opencart",
        capacita: ["menu-acquisti"],
      },
      {
        module: "Acquisti",
        path: "acquisti/spedizioni",
        title: 'menu.spedizioni',
        icon: "far fa-paper-plane"
      },
      {
        module: "Interventi",
        title: "Attività",
        icon: "mdi mdi-wrench",
        class: "has-arrow",
        capacita: ["menu-fasi"],
        submenu: [
          {
            path: "interventi/interventi",
            title: 'menu.interventi',
            icon: "mdi mdi-wrench",
          },
          {
            path: "interventi/gantt",
            title: "Gantt",
            icon: "mdi mdi-chart-areaspline",
          }
        ]
      },
      {
        module: "Documenti",
        path: "progetti/documenti",
        title: 'menu.DocumentiLabel',
        icon: "mdi mdi-file-document",
        capacita: ["menu-documenti"]
      },
      {
        module: "Prodotti",
        path: "progetti/prodotti/68/lista",
        title: 'menu.ProdottiLabel',
        icon: "mdi mdi-barcode-scan",
        capacita: ["menu-prodotti"],
        notruoliOperativi:["S"]
      },
      {
        module: "Prodotti",
        path: "progetti/prodotti/69/lista",
        title: 'Accessori',
        icon: "mdi mdi-barcode-scan",
        capacita: ["menu-prodotti"],
        notruoliOperativi:["S"]
      },
      // {
      //   module: "Prodotti",
      //   path: "progetti/prodotti/promozioni",
      //   title: 'Promozioni',
      //   icon: "mdi mdi-barcode-scan",
      //   capacita: ["menu-promozioni"]
      // },
      {
        module: "Formazione",
        title: 'menu.FormazioneLabel',
        icon: "mdi mdi-school",//mdi-calendar-multiple-check //mdi-engine-outline
        class: "has-arrow",
        capacita: ["menu-servizi", "menu-formazione", "menu-calendar-servizi", "menu-utenti-servizi"],
        submenu: [
          {
            path: "formazione/media",
            title: "menu.corsiMultimediali",
            icon: "mdi mdi-currency-eur",
            capacita: ["menu-formazione"]
          },
          {
            path: "formazione/corsi",
            title: "menu.corsi",
            icon: "mdi mdi-currency-eur",
            capacita: ["menu-calendar-servizi", "menu-servizi"]
          },
          {
            path: "/listautenti/personale/mod",
            title: "menu.docenti",
            icon: "mdi mdi-currency-eur",
            capacita: ["menu-utenti-servizi"]
          },
          {
            path: "/listautenti/personale/tut",
            title: "menu.tutor",
            icon: "mdi mdi-currency-eur",
            capacita: ["menu-utenti-servizi"]
          },
          {
            path: "/listautenti/personale/stu",
            title: "menu.studenti",
            icon: "mdi mdi-currency-eur",
            capacita: ["menu-utenti-servizi"]
          },
          {
            path: "formazione/materie",
            title: "menu.materie",
            icon: "mdi mdi-currency-eur",
            capacita: ["menu_calendar_tirocini"]
          },
          {
            path: "formazione/sedi",
            title: "menu.sedi",
            icon: "mdi mdi-currency-eur",
          }
        ]
      },
      {
        module: "Prima_Nota",
        title: "menu.Prima_NotaLabel",
        icon: "mdi mdi-cart",//mdi-calendar-multiple-check //mdi-engine-outline
        class: "has-arrow",
        capacita: ["menu-spese", "menu-fatture"],
        submenu: [
          {
            path: "primanota/fatture",
            title: "menu.fattVendita",
            capacita: ["menu-fatture"]
          },
          {
            path: "/listautenti/aziende/f",
            title: "menu.fornitori",
            capacita: ["menu-fatture"]
          },
          {
            path: "primanota/primanota",
            title: "menu.primanota",
            capacita: ["menu-spese"]
          },
          {
            path: "primanota/lista-spese",
            title: "menu.listaspese",
            capacita: ["menu-spese"]
          }
        ]
      },
      {
        module: "Parti",
        path: "progetti/parti",
        title: "menu.PartiLabel",
        icon: "mdi mdi-barcode",
        capacita: ["menu-parti"]
      },
      {
        module: "Parti",
        path: "progetti/parti/categorie-list",
        title: "Categorie Parti",
        icon: "mdi mdi-cart",
        capacita: ["menu-parti"]
      },
      {
        module: "Spedizioni",
        path: "spedizioni/lista",
        title: "menu.SpedizioniLabel",
        icon: "mdi mdi-airplane",
        capacita: ["menu-spedizioni"]
      },
      {
        module: "Stampe",
        path: "stampe/templates",
        title: "menu.StampeLabel",
        icon: "mdi mdi-printer",
        class: "has-arrow",
        capacita: ["menu-stampa"],
        submenu: [
          {
            path: "stampe/templates",
            title: "Templates",
            capacita: ["gestione-stampa"]
          },
          {
            path: "stampe/marker",
            title: "Marker",
            capacita: ["menu-stampa"]
          }
        ]
      },
      {
        module: "Settings",
        path: "settings/settings",
        title: "menu.SettingsLabel",
        icon: "mdi-settings",
        capacita: ["menu-settings"]
      },
      {
        module: "Prodotti",
        path: "/dashboard/categorie/P",
        title: "Categorie Attributi Filtrabili",
        icon: "fas fa-cogs",
        capacita: ["gestione-prodotti"]
      },
      // {
      //   module: "Prodotti",
      //   path: "/settings/setting/attributi_prodotto",
      //   title: "Attributi Filtrabili",
      //   icon: "fas fa-cogs",
      //   capacita: ["gestione-prodotti"]
      // },
      {
        module: "Prodotti",
        path: "/progetti/set/attributi",
        title: "Inserimento Attributi",
        icon: "fas fa-cogs",
        capacita: ["gestione-prodotti"]
      },
      {
        module: "Admin",
        path: "listautenti/roles",
        title: "Ruoli",
        icon: "mdi mdi-lock-open-outline",
        capacita: ["menu-ruoli"]
      },
      {
        module: "Ticket",
        path: "ticket/list",
        title: "Tickets",
        icon: "mdi mdi-bookmark-outline",
        capacita: ["menu-ticket"]
      },
      {
        ruoliOperativi: ["AC", "C", "CA"],
        path: 'Cliente/profile',
        title: 'menu.profilo',
        icon: "far fa-user"
      }
    ],
    //#endregion
  };
  env = addModule(Brandizzazioni(), env);
  env = addModule(Ritiri(), env);
  env = addModule(Promozioni(), env);
  env = addModule(ClientiTipizzati(),env);
  env = addModule(SanPellegrinoEnv(), env);
  env = addModule(AggiornamentoMassivoEnv(), env);
  return env;
};


